window.Instant = {
  initialized: true,
  initializedAppEmbed: true,
  initializedVersion: 'latest',
  swiperScriptUrl: 'https://cdn.jsdelivr.net/npm/swiper@11.0.3/swiper-bundle.min.js'
};


window.Instant = window.Instant || {};
window.Instant.initializedVersion = window.Instant?.initializedVersion || null;
window.Instant.initializedListeners = !!window.Instant?.initializedListeners;
window.Instant.initializedSwiper = !!window.Instant?.initializedSwiper;
window.Instant.initSwiper = window.Instant?.initSwiper || (() => {
    window.Instant.initializedSwiper || (window.Instant.initializedSwiper = !0, window.Instant.initializedListeners && window.__instantInitSliders?.())
});
(() => {
    function It(t) {
        fetch(`${window.Shopify?.routes?.root}cart/update.js`, {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                attributes: {
                    "_instant-cart": "true"
                }
            }),
            method: "POST"
        }).then(async e => {
            if (!e.ok) throw new Error;
            let n = await e.json();
            window.Shopify?.analytics.publish("instant:cart-drawer-opened", {
                context: {
                    layoutId: t,
                    localization: {
                        countryCode: window.Shopify?.country,
                        languageCode: `${window.Shopify?.locale}-${window.Shopify?.country}`
                    }
                },
                data: {
                    cart: n
                }
            })
        }).catch(e => {
            console.warn("Failed to publish cart drawer opened event", e)
        })
    }
    var Bn = new RegExp("^i[a-zA-Z0-9]{16}(-[a-zA-Z0-9]{16})*$"),
        Ee = t => Bn.test(t),
        xt = t => Ee(t) ? t.substring(1) : t,
        P = t => {
            let e = Array.from(t.classList);
            return e.find(n => Ee(n)) ?? e[0]
        },
        lt = t => {
            let e = t.getAttribute("data-instant-repeater-index");
            return `${xt(P(t))}${e != null ? `_${e}` : ""}`
        },
        ut = t => {
            let e = t.parentElement;
            return e instanceof HTMLSpanElement ? ut(e) : e
        },
        $t = (t, e) => {
            let n = t.querySelectorAll('[type="application/json"]'),
                o, i, r;
            return Array.from(n).forEach(a => {
                a.id.startsWith(`variants__${e}--`) && (o = JSON.parse(a.innerHTML)), a.id.startsWith(`options__${e}--`) && (i = JSON.parse(a.innerHTML)), a.id.startsWith(`selling_plans__${e}--`) && (r = JSON.parse(a.innerHTML))
            }), {
                variants: o,
                options: i,
                sellingPlans: r
            }
        },
        yt = t => {
            let e = t.getAttribute("href") ?? t.getAttribute("data-instant-href");
            if (e) {
                let n = document.createElement("a");
                return n.href = e, n.href
            }
            return null
        },
        ne = (t, e) => {
            t instanceof HTMLAnchorElement ? t.href = e : t.setAttribute("data-instant-href", e)
        },
        ht = t => t.closest(".__instant")?.getAttribute("data-instant-id"),
        ve = t => t.closest(".__instant")?.getAttribute("data-instant-layout"),
        kt = (t, e) => {
            let n;
            return (...o) => {
                clearTimeout(n), n = setTimeout(() => t(...o), e)
            }
        },
        Dt = () => !!document.querySelector('[data-instant-layout="CART"][data-instant-auto-connect-cart="true"]');
    var oe = t => `instant-countdown-end-${t}`,
        ie = t => {
            let e = t.getAttribute("data-instant-countdown-date"),
                n = t.getAttribute("data-instant-countdown-time-zone"),
                o = t.getAttribute("data-instant-countdown-minutes"),
                i = t.getAttribute("data-instant-countdown-is-persistent") === "true" || t.closest('[data-instant-layout="CART"]') !== null,
                r = t.getAttribute("data-instant-countdown-leading-zeros") === "true",
                a = !!e,
                s = ["DAYS", "HOURS", "MINUTES", "SECONDS"],
                [l, u, c, d] = s.map(R => t.querySelectorAll(`[data-instant-dynamic-content-source="COUNTDOWN_${R}"] span`)),
                f = R => {
                    let m = new Date,
                        g = m.getTime(),
                        H = (a ? -m.getTimezoneOffset() : 0) * 60 * 1e3;
                    return R - g + H
                },
                p = R => {
                    let m = R.toString();
                    return r ? m.padStart(2, "0") : m
                },
                h, b = oe(P(t)),
                w = sessionStorage.getItem(b);
            if (a) h = e ? new Date(e).getTime() : new Date().getTime();
            else if (w && i) h = Number(w);
            else {
                let R = new Date().getTime() + (o ? Number(o) : 0) * 60 * 1e3;
                i && !window?.Shopify?.designMode && sessionStorage.setItem(b, `${R}`), h = R
            }
            let S = (() => {
                    let R = new Date;
                    R.setSeconds(0, 0);
                    let m = R.toLocaleString("en-US", {
                            timeZone: n ?? "Etc/UTC",
                            hourCycle: "h23"
                        }),
                        g = /(\d+)\/(\d+)\/(\d+), (\d+):(\d+)/.exec(m);
                    if (g) {
                        let [H, T, O, v, q, k] = g.map(Number), B = Date.UTC(v, T - 1, O, q, k);
                        return Math.floor((B - R.getTime()) / (1e3 * 60))
                    }
                    return 0
                })(),
                x = (a ? S : 0) * 60 * 1e3,
                I = h - x,
                M = 0,
                _ = R => {
                    if (!t.isConnected) return;
                    let m = Math.ceil(f(I) / 1e3),
                        g = 0,
                        H = 0,
                        T = 0,
                        O = 0;
                    R - M >= 1e3 && (m > 0 && (O = Math.floor(m / (24 * 60 * 60)), T = Math.floor(m / (60 * 60) % 24), H = Math.floor(m / 60 % 60), g = Math.floor(m % 60)), l.length === 0 && O > 0 && (T = T + O * 24), u.length === 0 && T > 0 && (H = H + T * 60), c.length === 0 && H > 0 && (g = g + H * 60), Array.from(l).forEach(v => {
                        v.innerHTML = `${p(O)}`
                    }), Array.from(u).forEach(v => {
                        v.innerHTML = `${p(T)}`
                    }), Array.from(c).forEach(v => {
                        v.innerHTML = `${p(H)}`
                    }), Array.from(d).forEach(v => {
                        v.innerHTML = `${p(g)}`
                    }), M = R), m >= 0 && requestAnimationFrame(_)
                };
            requestAnimationFrame(_)
        },
        Te = t => {
            let e = t.querySelectorAll('[data-instant-type="countdown"]');
            Array.from(e).forEach(n => {
                ie(n)
            })
        };
    var Se = (t, e = !1) => {
            t.forEach(n => {
                let o = n.querySelector(':scope > [data-instant-type="accordion-content"]');
                if (o) {
                    let i = o.style.transitionDuration;
                    o.style.transitionDuration = "0s", o.style.setProperty("--instant-accordion-content-height", "initial"), o.style.setProperty("--instant-accordion-content-width", "initial");
                    let {
                        height: r,
                        width: a
                    } = o.getBoundingClientRect();
                    o.style.transitionDuration = i, o.style.setProperty("--instant-accordion-content-height", "0"), o.style.setProperty("--instant-accordion-content-width", "0");
                    let s = () => {
                        r && o.style.setProperty("--instant-accordion-content-height", `${r}px`), a && o.style.setProperty("--instant-accordion-content-width", `${a}px`)
                    };
                    e ? s() : "requestAnimationFrame" in window ? window.requestAnimationFrame(s) : setTimeout(s, 16)
                }
            })
        },
        Le = t => {
            let e = t.querySelectorAll('[data-instant-type="accordion-container"]');
            Array.from(e).reverse().forEach(n => {
                let o = n.getAttribute("data-is-multi-open-enabled") === "true",
                    i = n.querySelectorAll(':scope > [data-instant-type="accordion-item"]');
                Se(Array.from(i), !0), Array.from(i).forEach(r => {
                    let a = r.querySelector(':scope > [data-instant-type="accordion-header"]');
                    a && a.addEventListener("click", () => {
                        let s = r.getAttribute("data-state") === "open";
                        r.setAttribute("data-state", s ? "closed" : "open"), s || Se([r]), o || Array.from(i).forEach(l => {
                            l !== r && l.getAttribute("data-state") === "open" && l.setAttribute("data-state", "closed")
                        })
                    }, {
                        signal: window.Instant.eventAbortController.signal
                    })
                })
            })
        };
    var Fn = (t, e) => t?.replace(/:(-?\d+)/, `:${e}`),
        Vn = t => t.match(/:(-?\d+)/)?.[1],
        Pe = ["PRICE", "COMPARE_AT", "SAVED_AMOUNT", "SAVED_PERCENTAGE"],
        Ie = ["SKU", "VARIANT_TITLE", "VARIANT_METAFIELD", "OPTION1", "OPTION2", "OPTION3", "QUANTITY_AVAILABLE"],
        re = ["add-to-cart", "add-to-instant-cart", "redirect-to-cart", "redirect-to-checkout", "toggle-addon"],
        xe = re.map(t => `[data-instant-action-type="${t}"]`).join(", "),
        Bt = ({
            variantId: t,
            scope: e,
            scopeId: n,
            quantity: o,
            selectedSellingPlan: i,
            skipVariantUrlUpdate: r
        }) => {
            let a = e.getAttribute("data-instant-form-product-url"),
                s = e.closest(".__instant")?.getAttribute("data-section-id"),
                l = Pe.map(m => `[data-instant-dynamic-content-source="${m}"]`).join(", "),
                u = e.querySelectorAll(l),
                c = Ie.map(m => `[data-instant-dynamic-content-source="${m}"]`).join(", "),
                d = e.querySelectorAll(c),
                f = e.querySelectorAll('fieldset[data-instant-type="VARIANT_PICKER"] select option'),
                p = e.querySelectorAll('fieldset[data-instant-type="VARIANT_PICKER"] input[type="radio"]'),
                h = e.querySelectorAll('img[data-instant-dynamic-content-source="FEATURED_IMAGE"]'),
                b = e.querySelectorAll('img[data-instant-dynamic-content-source="REPEATER"]'),
                w = Array.from(e.querySelectorAll(xe));
            e.getAttribute("data-instant-action-type") && re.includes(e.getAttribute("data-instant-action-type")) && w.push(e);
            let A = Array.from(e.querySelectorAll('[data-instant-action-type="open-page"]'));
            e.getAttribute("data-instant-action-type") === "open-page" && A.push(e);
            let S = e.querySelectorAll('[data-instant-action-type="select-variant-option"]'),
                x = e.querySelectorAll('[data-instant-action-type="select-selling-plan"]'),
                I = e.querySelectorAll('fieldset[data-instant-type="SELLING_PLAN_PICKER"] input[type="radio"]'),
                M = e.querySelectorAll('fieldset[data-instant-type="SELLING_PLAN_PICKER"] select'),
                _ = e.querySelectorAll("[data-instant-conditional]");
            if (!t) {
                for (let m of [...u, ...d]) m?.closest("[data-instant-form-product-url]") === e && m && (m.innerHTML = "&nbsp;");
                for (let m of w) m.closest("[data-instant-form-product-url]") === e && m && m.setAttribute("data-instant-disabled", "true");
                for (let m of f)
                    if (m?.closest("[data-instant-form-product-url]") === e && m) {
                        let g = m?.closest('fieldset[data-instant-type="VARIANT_PICKER"]')?.querySelector('span[data-instant-type="selected-variant-option"]'),
                            H = m.closest("select");
                        m.value === H?.value ? (m.setAttribute("selected", ""), g && (g.innerHTML = m.innerHTML)) : m.removeAttribute("selected")
                    } return
            }
            if (!r && e.closest('[data-instant-layout="PRODUCT_TEMPLATE"]') && e.getAttribute("data-instant-type") === "root") {
                let m = new URL(window.location.toString()),
                    g = m.searchParams.get("variant"),
                    H = e.getAttribute("data-instant-form-variant-id");
                (g || t !== H) && (m.searchParams.set("variant", t), window.history.replaceState({}, "", m.toString()))
            }
            let R = new URLSearchParams({
                variant: t,
                section_id: s
            });
            i?.sellingPlanId && R.set("selling_plan", i.sellingPlanId), fetch(`${a}?${R.toString()}`).then(m => m.text()).then(m => {
                let g = new DOMParser().parseFromString(m, "text/html"),
                    H = e.getAttribute("data-instant-form-product-url"),
                    [T, O] = n.split("_"),
                    v = g.querySelector(`[class*="i${T}"]${O != null ? `[data-instant-repeater-index="${O}"]` : ""}[data-instant-form-product-url="${H}"]`);
                if (!v) {
                    console.warn("Could not find source element in response");
                    return
                }
                let q = Pe.map(y => `[data-instant-dynamic-content-source="${y}"]`).join(", "),
                    k = Array.from(v.querySelectorAll(q)),
                    B = Ie.map(y => `[data-instant-dynamic-content-source="${y}"]`).join(", "),
                    F = Array.from(v.querySelectorAll(B)),
                    V = Array.from(v?.querySelectorAll('fieldset[data-instant-type="VARIANT_PICKER"] input[type="radio"]')),
                    U = Array.from(v?.querySelectorAll('fieldset[data-instant-type="VARIANT_PICKER"] select option')),
                    Nt = Array.from(v?.querySelectorAll('[data-instant-action-type="select-variant-option"]')),
                    dt = Array.from(v?.querySelectorAll('fieldset[data-instant-type="SELLING_PLAN_PICKER"] input[type="radio"]')),
                    Zt = Array.from(v?.querySelectorAll('fieldset[data-instant-type="SELLING_PLAN_PICKER"] select')),
                    N = Array.from(v?.querySelectorAll('span[data-instant-type="selected-selling-plan-option"]')),
                    $ = Array.from(v?.querySelectorAll(xe));
                v?.getAttribute("data-instant-action-type") && re.includes(v.getAttribute("data-instant-action-type")) && $.push(v);
                let J = Array.from(v?.querySelectorAll('[data-instant-action-type="open-page"]'));
                v?.getAttribute("data-instant-action-type") === "open-page" && J.push(v);
                let nt = Array.from(v?.querySelectorAll('img[data-instant-dynamic-content-source="FEATURED_IMAGE"]')),
                    at = Array.from(v?.querySelectorAll('img[data-instant-dynamic-content-source="REPEATER"]')),
                    kn = Array.from(v?.querySelectorAll("[data-instant-conditional]")),
                    te = document.querySelector(`input[name="${n}__selling-plan-id"]`),
                    be = document.querySelector(`input[name="${n}__selling-plan-name"]`),
                    Ae = !1,
                    Dn = e.querySelectorAll('span[data-instant-type="selected-selling-plan-option"]');
                for (let y of Dn) {
                    let L = P(y),
                        E = N.find(C => P(C) === L);
                    E?.closest("[data-instant-form-product-url]") === v && E && (y.innerHTML = E.innerHTML)
                }
                for (let y of I) {
                    let L = dt.find(E => E.id === y.id);
                    if (L?.closest("[data-instant-form-product-url]") === v && L) {
                        let E = L.getAttribute("data-instant-disabled");
                        E ? y.setAttribute("data-instant-disabled", E) : y.removeAttribute("data-instant-disabled"), L.hasAttribute("checked") ? y.checked = !0 : y.checked = !1, y.value = L.value;
                        let C;
                        if (y.labels && ([C] = Array.from(y.labels)), C) {
                            let D;
                            if (L.labels && ([D] = Array.from(L.labels)), D) {
                                C.innerHTML = D.innerHTML;
                                let W = D.getAttribute("title");
                                W && C.setAttribute("title", W)
                            }
                        }
                    }
                }
                for (let y of M) {
                    let L = Zt.find(E => E.id === y.id);
                    L?.closest("[data-instant-form-product-url]") === v && (y.innerHTML = L.innerHTML)
                }
                for (let y of u) {
                    let L = P(y),
                        E = k.find(C => P(C) === L);
                    if (E?.closest("[data-instant-form-product-url]") === v && E) {
                        Ae ? y.innerHTML = "&nbsp;" : y.innerHTML = E.innerHTML;
                        let C = E.getAttribute("style");
                        C ? y.setAttribute("style", C) : y.removeAttribute("style")
                    }
                }
                for (let y of x) {
                    let L = P(y),
                        E = Array.from(v?.querySelectorAll('[data-instant-action-type="select-selling-plan"]')).find(st => P(st) === L);
                    if (E?.closest("[data-instant-form-product-url]") !== v) continue;
                    let C = y?.querySelectorAll('[data-instant-type="SELLING_PLAN_PICKER"]'),
                        D = decodeURIComponent(E.getAttribute("data-instant-selling-plan-name")),
                        W = E.getAttribute("data-instant-selling-plan-id");
                    if (!i && W === "one-time-purchase") {
                        y.setAttribute("data-instant-state", "active");
                        continue
                    }
                    if (i?.sellingPlanId === W || i?.sellingPlanName === D) {
                        y.setAttribute("data-instant-state", "active"), E.getAttribute("data-instant-disabled") === "true" && (Ae = !0);
                        continue
                    }
                    if (C?.length > 0 && i && i.sellingPlanId !== "one-time-purchase") {
                        y.setAttribute("data-instant-state", "active");
                        let st = Array.from(y.querySelectorAll(q));
                        for (let ee of st) {
                            let we = ee.getAttribute("data-instant-dynamic-content-source");
                            we === "PRICE" ? ee.innerHTML = i.price : we === "COMPARE_AT" && (ee.innerHTML = i.compareAtPrice)
                        }
                        continue
                    }
                    y.setAttribute("data-instant-state", "inactive")
                }
                for (let y of d) {
                    let L = P(y),
                        E = F.find(C => P(C) === L);
                    E?.closest("[data-instant-form-product-url]") === v && E && (y.innerHTML = E.innerHTML)
                }
                for (let y of p) {
                    let L = V.find(E => E.id === y.id);
                    if (L?.closest("[data-instant-form-product-url]") === v && L) {
                        let E = L.getAttribute("data-instant-disabled");
                        E ? y.setAttribute("data-instant-disabled", E) : y.removeAttribute("data-instant-disabled"), L.hasAttribute("checked") ? y.checked = !0 : y.checked = !1;
                        let C;
                        if (y.labels && ([C] = Array.from(y.labels)), C) {
                            let D;
                            if (L.labels && ([D] = Array.from(L.labels)), D) {
                                let W = D.getAttribute("title");
                                W && C.setAttribute("title", W)
                            }
                        }
                    }
                }
                for (let y of f) {
                    let L = U.find(E => E.id === y.id);
                    if (L?.closest("[data-instant-form-product-url]") === v && L) {
                        let E = L.getAttribute("data-instant-disabled");
                        E ? y.setAttribute("data-instant-disabled", E) : y.removeAttribute("data-instant-disabled"), y.textContent = L.textContent;
                        let C = y?.closest('fieldset[data-instant-type="VARIANT_PICKER"]')?.querySelector('span[data-instant-type="selected-variant-option"]');
                        L.hasAttribute("selected") ? (y.setAttribute("selected", ""), C && (C.innerHTML = L.innerHTML)) : y.removeAttribute("selected")
                    }
                }
                for (let y of h) {
                    let L = P(ut(y)),
                        E = nt.find(C => P(ut(C)) === L);
                    if (E?.closest("[data-instant-form-product-url]") === v && E) {
                        y.alt = E.alt, y.height = E.height, y.width = E.width;
                        let C = window.TranslationLab?.CustomTranslations?.getImageTranslation(E.src);
                        C && C !== E.src ? (y.src = C, y.sizes = "", y.srcset = "") : (y.src = E.src, y.sizes = E.sizes, y.srcset = E.srcset)
                    }
                }
                for (let y of b) {
                    if (window.is_rubik_active && v.closest('[data-instant-layout="PRODUCT_TEMPLATE"]') && v.getAttribute("data-instant-type") === "root") continue;
                    let L = at.find(E => E.getAttribute("data-instant-repeater-id") === y.getAttribute("data-instant-repeater-id") && E.getAttribute("data-instant-repeater-index") === y.getAttribute("data-instant-repeater-index"));
                    if (L?.closest("[data-instant-form-product-url]") === v && L) {
                        y.alt = L.alt, y.height = L.height, y.width = L.width;
                        let E = window.TranslationLab?.CustomTranslations?.getImageTranslation(L.src);
                        E && E !== L.src ? (y.src = E, y.sizes = "", y.srcset = "") : (y.src = L.src, y.sizes = L.sizes, y.srcset = L.srcset);
                        let C = y.closest(".instant-slider");
                        C?.swiper && C.swiper.realIndex !== 0 && C?.closest("[data-instant-form-product-url]") === e && C.swiper.slideTo(0, 0)
                    }
                }
                for (let y of w) {
                    let L = P(y),
                        E = $.find(C => P(C) === L);
                    if (E?.closest("[data-instant-form-product-url]") === v && E) {
                        E.getAttribute("data-instant-disabled") === "true" ? y.setAttribute("data-instant-disabled", "true") : y.removeAttribute("data-instant-disabled");
                        let D = E.getAttribute("data-instant-state");
                        D ? y.setAttribute("data-instant-state", D) : y.removeAttribute("data-instant-state");
                        for (let st of x) st.getAttribute("data-instant-state") === "active" && st.getAttribute("data-instant-disabled") === "true" && y.setAttribute("data-instant-disabled", "true");
                        y.setAttribute("data-instant-action-variant-id", t);
                        let W = yt(E);
                        if (W) {
                            let st = parseInt(Vn(W) ?? "1", 10);
                            o && st === 1 && (W = Fn(W, String(o))), ne(y, W)
                        }
                    }
                }
                for (let y of A) {
                    let L = P(y),
                        E = J.find(C => P(C) === L);
                    if (E?.closest("[data-instant-form-product-url]") === v && E) {
                        let C = yt(E);
                        if (C) {
                            let D = new URL(C);
                            D.searchParams.set("variant", t), ne(y, D.toString())
                        }
                    }
                }
                for (let y of S) {
                    let L = P(y),
                        E = Nt.find(C => P(C) === L);
                    E?.closest("[data-instant-form-product-url]") === v && E && (y.setAttribute("data-instant-state", E.getAttribute("data-instant-state") ?? "inactive"), y.setAttribute("data-instant-disabled", E.getAttribute("data-instant-disabled") ?? ""))
                }
                i || (be && be.remove(), te && te.value !== "one-time-purchase" && te.remove());
                for (let y of _) {
                    let L = P(y),
                        E = kn.find(D => P(D) === L);
                    if (E?.closest("[data-instant-form-product-url]") !== v) continue;
                    let C = E.getAttribute("style");
                    C ? y.setAttribute("style", C) : y.removeAttribute("style")
                }
            })
        },
        X = (t, e, n) => {
            let o = t.querySelector(`input[name="${e}"]`);
            if (o) {
                o.value = n;
                return
            }
            let i = document.createElement("input");
            t.appendChild(i), i.setAttribute("type", "hidden"), i.setAttribute("name", e), i.setAttribute("value", n)
        },
        Ft = t => {
            let e = t.querySelectorAll("[data-instant-product-recommendations]");
            Array.from(e).forEach(n => {
                let o = n.getAttribute("data-instant-product-recommendations");
                if (o && n instanceof HTMLElement) {
                    if (n.getAttribute("data-instant-observed")) return;
                    n.setAttribute("data-instant-observed", "true"), n.style.display = "block";
                    let i = (a, s) => {
                        if (!a[0].isIntersecting) return;
                        s.unobserve(n);
                        let l = n.getAttribute("data-url");
                        l && fetch(l).then(u => u.text()).then(u => {
                            let d = new DOMParser().parseFromString(u, "text/html").querySelector(`[data-instant-product-recommendations-output="${o}"]`);
                            d && d.innerHTML.trim().length && (n.insertAdjacentHTML("afterend", d.innerHTML), bt(), n.remove())
                        }).catch(u => {
                            console.error(u)
                        })
                    };
                    new IntersectionObserver(i, {
                        rootMargin: "0px 0px 200px 0px"
                    }).observe(n)
                }
            })
        };
    var Vt = t => t.querySelector("kaching-bundles-block"),
        Ce = () => {
            document.addEventListener("kaching-bundles-block-loaded", t => {
                if ("detail" in t) {
                    let {
                        component: e
                    } = t.detail, n = e.closest("[data-instant-form-product-url]");
                    if (n) {
                        let o = lt(n);
                        window.kachingBundlesDisableAddToCartHandling = !0, e.addEventListener("variant-selected", i => {
                            if ("detail" in i) {
                                let {
                                    variantId: r
                                } = i.detail;
                                Bt({
                                    variantId: r,
                                    scope: n,
                                    scopeId: o,
                                    quantity: 1,
                                    skipVariantUrlUpdate: !0
                                })
                            }
                        }, {
                            signal: window.Instant.eventAbortController.signal
                        })
                    }
                }
            }, {
                signal: window.Instant.eventAbortController.signal
            })
        },
        Me = t => t.querySelector('input[data-timesact-selling-plan][name="selling_plan"]')?.value ?? null,
        He = () => {
            !!document.querySelector('script[src*="3ee93129-d11c-4adb-8a29-0c9bec8a2202"]') && document.querySelectorAll("form[data-instant-form-product-id]").forEach(e => {
                let n = e.getAttribute("data-instant-form-product-id");
                n && (e.classList.add("timesact-form"), e.setAttribute("data-productid", n))
            })
        };
    var ae = (t, e = {
            replace: !1
        }) => {
            let n = new URL(window.location.toString());
            return n.searchParams.get(t.key) && !e.replace ? n.searchParams.getAll(t.key).includes(t.value) ? n.searchParams.delete(t.key, t.value) : n.searchParams.append(t.key, t.value) : n.searchParams.set(t.key, t.value), window.history.pushState({}, "", n.toString()), n
        },
        _e = async t => fetch(t).then(e => {
            if (!e.ok) throw new Error(`Error fetching section (${e.status})`);
            return e.text()
        }).then(e => new DOMParser().parseFromString(e, "text/html")).catch(e => console.error(e)), Un = (t, e) => {
            let n = Array.from(t.querySelectorAll('[data-instant-type="filter-container"]')),
                o = Array.from(e.querySelectorAll('[data-instant-type="filter-container"]'));
            for (let i of n) {
                let r = P(i),
                    a = o.find(s => P(s) === r);
                a && (i.innerHTML = a.innerHTML)
            }
        }, zn = (t, e) => {
            let n = Array.from(t.querySelectorAll(`[data-instant-type="sort-container"] [data-instant-dynamic-content-source="${"SELECTED_SORT_OPTION"}"]`)),
                o = Array.from(e.querySelectorAll(`[data-instant-type="sort-container"] [data-instant-dynamic-content-source="${"SELECTED_SORT_OPTION"}"]`));
            for (let i of n) {
                let r = P(i),
                    a = o.find(s => P(s) === r);
                a && (i.textContent = a.textContent)
            }
        }, Wn = (t, e) => {
            let n = Array.from(t.querySelectorAll('[data-instant-action-type="clear-filters"]')),
                o = Array.from(e.querySelectorAll('[data-instant-action-type="clear-filters"]'));
            for (let i of n) {
                let r = P(i),
                    a = o.find(s => P(s) === r);
                a && i.setAttribute("data-instant-visibility", a.getAttribute("data-instant-visibility") ?? "hidden")
            }
        }, Re = async t => {
            let e = t.closest(".__instant");
            if (!e) {
                console.error("Scope not found");
                return
            }
            let n = Array.from(e.querySelectorAll("[data-instant-form-product-url][data-instant-form-collection-url]")),
                o = Number(t.getAttribute("data-instant-action-page-param")),
                i = new URL(window.location.toString());
            i.searchParams.set("page", (o + 1).toString());
            let r = await _e(i.toString());
            if (!r) {
                console.error("Error rendering updated HTML");
                return
            }
            let a = Array.from(e.querySelectorAll("[data-instant-form-product-url][data-instant-form-collection-url]")).pop(),
                s = a?.parentElement;
            if (!s) {
                console.error("Last product has no parent element");
                return
            }
            let l = r.querySelector(`.${P(s)}`);
            if (!l) {
                console.error("Updated product parent not found");
                return
            }
            let u = Array.from(l.querySelectorAll("[data-instant-form-product-url][data-instant-form-collection-url]")),
                c = new Set(n.map(p => p.getAttribute("data-instant-form-product-url"))),
                d = [];
            for (let p of u) {
                let h = p.getAttribute("data-instant-form-product-url");
                !h || c.has(h) || d.some(b => b.getAttribute("data-instant-form-product-url") === h) || d.push(p)
            }
            let f = t.getAttribute("data-instant-action-limit");
            if (f) {
                let p = Number(f);
                d.length > p && (d = d.slice(0, p))
            }
            a && a.after(...d), t.setAttribute("data-instant-action-page-param", (o + 1).toString()), Ut(e), bt()
        }, qe = async t => {
            let e = t.closest(".__instant");
            if (!e) {
                console.error("Scope not found");
                return
            }
            let n = new URL(window.location.toString()),
                o = Array.from(n.searchParams.entries()).filter(([i]) => i.startsWith("filter."));
            if (o.length === 0) {
                console.error("No filters to clear");
                return
            }
            for (let [i, r] of o) n.searchParams.delete(i, r);
            window.history.pushState({}, "", n.toString()), zt({
                scope: e,
                url: n
            })
        }, jn = (t, e) => {
            let n = e.querySelector(`.${P(t)}`);
            if (!n) {
                console.error("Updated scope not found");
                return
            }
            let o = Array.from(n.querySelectorAll("[data-instant-form-product-url][data-instant-form-collection-url]")).map(s => s.parentElement).filter(Boolean),
                i = Array.from(new Map(o.map(s => [P(s), s])).values());
            for (let s of i) {
                let l = P(s),
                    u = t.querySelector(`.${l}`);
                u && (u.innerHTML = s.innerHTML)
            }
            let r = Array.from(t.querySelectorAll("[data-instant-form-product-url][data-instant-form-collection-url]")).map(s => s.parentElement).filter(Boolean),
                a = new Set(i.map(s => P(s)));
            for (let s of r) {
                let l = P(s);
                a.has(l) || (s.innerHTML = "")
            }
            Ut(t)
        }, Kn = (t, e) => {
            let n = Array.from(t.querySelectorAll('[data-instant-action-type="load-more"]')),
                o = Array.from(e.querySelectorAll('[data-instant-action-type="load-more"]'));
            for (let i of n) {
                let r = P(i),
                    a = o.find(s => P(s) === r);
                a && (i.setAttribute("data-instant-visibility", a.getAttribute("data-instant-visibility") ?? "visible"), i.setAttribute("data-instant-action-page-param", a.getAttribute("data-instant-action-page-param") ?? "1"), i.setAttribute("data-instant-product-count", a.getAttribute("data-instant-product-count") ?? "100"))
            }
        }, Ut = t => {
            let e = Array.from(t.querySelectorAll('[data-instant-action-type="load-more"]'));
            for (let n of e)
                if (n?.getAttribute("data-instant-product-count")) {
                    let o = Number(n.getAttribute("data-instant-product-count"));
                    if (o) {
                        let i = Array.from(t.querySelectorAll("[data-instant-form-product-url][data-instant-form-collection-url]")),
                            r = new Set(i.map(a => a.getAttribute("data-instant-form-product-url")));
                        n.setAttribute("data-instant-visibility", r.size < o ? "visible" : "hidden")
                    }
                }
        }, zt = async ({
            scope: t,
            url: e
        }) => {
            let n = t.closest(".__instant")?.getAttribute("data-section-id");
            if (!n) {
                console.error("Section ID not found");
                return
            }
            e.searchParams.set("section_id", n);
            let o = await _e(e.toString());
            if (!o) {
                console.error("Error rendering updated HTML");
                return
            }
            if (!o.querySelector(`[data-section-id="${n}"]`)) {
                console.error("Error finding updated section");
                return
            }
            Un(t, o), zn(t, o), Wn(t, o), Kn(t, o), jn(t, o), bt(), window.okeWidgetApi?.initAllWidgets()
        }, Oe = t => {
            let e = Array.from(document.querySelectorAll("[data-instant-form-product-url][data-instant-form-collection-url]")),
                n = {};
            for (let i of e) {
                let r = i.parentElement;
                if (!r) continue;
                let a = P(r);
                n[a] || (n[a] = r.innerHTML)
            }
            let o = {
                scrollPosition: {
                    x: window.scrollX,
                    y: window.scrollY
                },
                productParents: n,
                loadMoreButtonVisibility: document.querySelector('[data-instant-action-type="load-more"]')?.getAttribute("data-instant-visibility")
            };
            sessionStorage.setItem(t, JSON.stringify(o))
        }, Yn = t => {
            let e = JSON.parse(sessionStorage.getItem(t) ?? "{}");
            if (e.productParents)
                for (let o of Object.keys(e.productParents)) {
                    let i = document.querySelector(`.${o}`);
                    i && (i.innerHTML = e.productParents[o])
                }
            e.scrollPosition && window.scrollTo(e.scrollPosition.x, e.scrollPosition.y);
            let n = document.querySelector('[data-instant-action-type="load-more"]');
            n && n.setAttribute("data-instant-visibility", e?.loadMoreButtonVisibility ?? "visible"), bt()
        }, Ne = () => {
            let t = new URL(window.location.toString());
            if (!t.pathname.includes("/collections/")) return;
            window.Instant.performanceObserver && window.Instant.performanceObserver.disconnect(), window.Instant.performanceObserver = new PerformanceObserver(o => {
                o.getEntries()[0].toJSON().type === "back_forward" && Yn(t.pathname)
            }), window.Instant.performanceObserver.observe({
                entryTypes: ["navigation"]
            });
            let n = window.open;
            window.open = (...o) => (Oe(t.pathname), n.apply(window, o)), document.addEventListener("click", o => {
                let r = o.target.closest("a");
                r && !r.getAttribute("data-instant-action-type") && Oe(t.pathname)
            }, {
                signal: window.Instant.eventAbortController.signal,
                capture: !0
            })
        };
    var Z = Math.min,
        z = Math.max,
        Mt = Math.round,
        Ht = Math.floor,
        ot = t => ({
            x: t,
            y: t
        }),
        Gn = {
            left: "right",
            right: "left",
            bottom: "top",
            top: "bottom"
        },
        Qn = {
            start: "end",
            end: "start"
        };

    function se(t, e, n) {
        return z(t, Z(e, n))
    }

    function ct(t, e) {
        return typeof t == "function" ? t(e) : t
    }

    function tt(t) {
        return t.split("-")[0]
    }

    function At(t) {
        return t.split("-")[1]
    }

    function jt(t) {
        return t === "x" ? "y" : "x"
    }

    function le(t) {
        return t === "y" ? "height" : "width"
    }

    function it(t) {
        return ["top", "bottom"].includes(tt(t)) ? "y" : "x"
    }

    function ce(t) {
        return jt(it(t))
    }

    function $e(t, e, n) {
        n === void 0 && (n = !1);
        let o = At(t),
            i = ce(t),
            r = le(i),
            a = i === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
        return e.reference[r] > e.floating[r] && (a = Ct(a)), [a, Ct(a)]
    }

    function ke(t) {
        let e = Ct(t);
        return [Wt(t), e, Wt(e)]
    }

    function Wt(t) {
        return t.replace(/start|end/g, e => Qn[e])
    }

    function Jn(t, e, n) {
        let o = ["left", "right"],
            i = ["right", "left"],
            r = ["top", "bottom"],
            a = ["bottom", "top"];
        switch (t) {
            case "top":
            case "bottom":
                return n ? e ? i : o : e ? o : i;
            case "left":
            case "right":
                return e ? r : a;
            default:
                return []
        }
    }

    function De(t, e, n, o) {
        let i = At(t),
            r = Jn(tt(t), n === "start", o);
        return i && (r = r.map(a => a + "-" + i), e && (r = r.concat(r.map(Wt)))), r
    }

    function Ct(t) {
        return t.replace(/left|right|bottom|top/g, e => Gn[e])
    }

    function Xn(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        }
    }

    function Be(t) {
        return typeof t != "number" ? Xn(t) : {
            top: t,
            right: t,
            bottom: t,
            left: t
        }
    }

    function ft(t) {
        let {
            x: e,
            y: n,
            width: o,
            height: i
        } = t;
        return {
            width: o,
            height: i,
            top: n,
            left: e,
            right: e + o,
            bottom: n + i,
            x: e,
            y: n
        }
    }

    function Fe(t, e, n) {
        let {
            reference: o,
            floating: i
        } = t, r = it(e), a = ce(e), s = le(a), l = tt(e), u = r === "y", c = o.x + o.width / 2 - i.width / 2, d = o.y + o.height / 2 - i.height / 2, f = o[s] / 2 - i[s] / 2, p;
        switch (l) {
            case "top":
                p = {
                    x: c,
                    y: o.y - i.height
                };
                break;
            case "bottom":
                p = {
                    x: c,
                    y: o.y + o.height
                };
                break;
            case "right":
                p = {
                    x: o.x + o.width,
                    y: d
                };
                break;
            case "left":
                p = {
                    x: o.x - i.width,
                    y: d
                };
                break;
            default:
                p = {
                    x: o.x,
                    y: o.y
                }
        }
        switch (At(e)) {
            case "start":
                p[a] -= f * (n && u ? -1 : 1);
                break;
            case "end":
                p[a] += f * (n && u ? -1 : 1);
                break
        }
        return p
    }
    var Ve = async (t, e, n) => {
        let {
            placement: o = "bottom",
            strategy: i = "absolute",
            middleware: r = [],
            platform: a
        } = n, s = r.filter(Boolean), l = await (a.isRTL == null ? void 0 : a.isRTL(e)), u = await a.getElementRects({
            reference: t,
            floating: e,
            strategy: i
        }), {
            x: c,
            y: d
        } = Fe(u, o, l), f = o, p = {}, h = 0;
        for (let b = 0; b < s.length; b++) {
            let {
                name: w,
                fn: A
            } = s[b], {
                x: S,
                y: x,
                data: I,
                reset: M
            } = await A({
                x: c,
                y: d,
                initialPlacement: o,
                placement: f,
                strategy: i,
                middlewareData: p,
                rects: u,
                platform: a,
                elements: {
                    reference: t,
                    floating: e
                }
            });
            c = S ?? c, d = x ?? d, p = {
                ...p,
                [w]: {
                    ...p[w],
                    ...I
                }
            }, M && h <= 50 && (h++, typeof M == "object" && (M.placement && (f = M.placement), M.rects && (u = M.rects === !0 ? await a.getElementRects({
                reference: t,
                floating: e,
                strategy: i
            }) : M.rects), {
                x: c,
                y: d
            } = Fe(u, f, l)), b = -1)
        }
        return {
            x: c,
            y: d,
            placement: f,
            strategy: i,
            middlewareData: p
        }
    };
    async function Kt(t, e) {
        var n;
        e === void 0 && (e = {});
        let {
            x: o,
            y: i,
            platform: r,
            rects: a,
            elements: s,
            strategy: l
        } = t, {
            boundary: u = "clippingAncestors",
            rootBoundary: c = "viewport",
            elementContext: d = "floating",
            altBoundary: f = !1,
            padding: p = 0
        } = ct(e, t), h = Be(p), w = s[f ? d === "floating" ? "reference" : "floating" : d], A = ft(await r.getClippingRect({
            element: (n = await (r.isElement == null ? void 0 : r.isElement(w))) == null || n ? w : w.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(s.floating)),
            boundary: u,
            rootBoundary: c,
            strategy: l
        })), S = d === "floating" ? {
            x: o,
            y: i,
            width: a.floating.width,
            height: a.floating.height
        } : a.reference, x = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(s.floating)), I = await (r.isElement == null ? void 0 : r.isElement(x)) ? await (r.getScale == null ? void 0 : r.getScale(x)) || {
            x: 1,
            y: 1
        } : {
            x: 1,
            y: 1
        }, M = ft(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
            elements: s,
            rect: S,
            offsetParent: x,
            strategy: l
        }) : S);
        return {
            top: (A.top - M.top + h.top) / I.y,
            bottom: (M.bottom - A.bottom + h.bottom) / I.y,
            left: (A.left - M.left + h.left) / I.x,
            right: (M.right - A.right + h.right) / I.x
        }
    }
    var Ue = function(t) {
        return t === void 0 && (t = {}), {
            name: "flip",
            options: t,
            async fn(e) {
                var n, o;
                let {
                    placement: i,
                    middlewareData: r,
                    rects: a,
                    initialPlacement: s,
                    platform: l,
                    elements: u
                } = e, {
                    mainAxis: c = !0,
                    crossAxis: d = !0,
                    fallbackPlacements: f,
                    fallbackStrategy: p = "bestFit",
                    fallbackAxisSideDirection: h = "none",
                    flipAlignment: b = !0,
                    ...w
                } = ct(t, e);
                if ((n = r.arrow) != null && n.alignmentOffset) return {};
                let A = tt(i),
                    S = it(s),
                    x = tt(s) === s,
                    I = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)),
                    M = f || (x || !b ? [Ct(s)] : ke(s)),
                    _ = h !== "none";
                !f && _ && M.push(...De(s, b, h, I));
                let R = [s, ...M],
                    m = await Kt(e, w),
                    g = [],
                    H = ((o = r.flip) == null ? void 0 : o.overflows) || [];
                if (c && g.push(m[A]), d) {
                    let q = $e(i, a, I);
                    g.push(m[q[0]], m[q[1]])
                }
                if (H = [...H, {
                        placement: i,
                        overflows: g
                    }], !g.every(q => q <= 0)) {
                    var T, O;
                    let q = (((T = r.flip) == null ? void 0 : T.index) || 0) + 1,
                        k = R[q];
                    if (k) return {
                        data: {
                            index: q,
                            overflows: H
                        },
                        reset: {
                            placement: k
                        }
                    };
                    let B = (O = H.filter(F => F.overflows[0] <= 0).sort((F, V) => F.overflows[1] - V.overflows[1])[0]) == null ? void 0 : O.placement;
                    if (!B) switch (p) {
                        case "bestFit": {
                            var v;
                            let F = (v = H.filter(V => {
                                if (_) {
                                    let U = it(V.placement);
                                    return U === S || U === "y"
                                }
                                return !0
                            }).map(V => [V.placement, V.overflows.filter(U => U > 0).reduce((U, Nt) => U + Nt, 0)]).sort((V, U) => V[1] - U[1])[0]) == null ? void 0 : v[0];
                            F && (B = F);
                            break
                        }
                        case "initialPlacement":
                            B = s;
                            break
                    }
                    if (i !== B) return {
                        reset: {
                            placement: B
                        }
                    }
                }
                return {}
            }
        }
    };
    async function Zn(t, e) {
        let {
            placement: n,
            platform: o,
            elements: i
        } = t, r = await (o.isRTL == null ? void 0 : o.isRTL(i.floating)), a = tt(n), s = At(n), l = it(n) === "y", u = ["left", "top"].includes(a) ? -1 : 1, c = r && l ? -1 : 1, d = ct(e, t), {
            mainAxis: f,
            crossAxis: p,
            alignmentAxis: h
        } = typeof d == "number" ? {
            mainAxis: d,
            crossAxis: 0,
            alignmentAxis: null
        } : {
            mainAxis: 0,
            crossAxis: 0,
            alignmentAxis: null,
            ...d
        };
        return s && typeof h == "number" && (p = s === "end" ? h * -1 : h), l ? {
            x: p * c,
            y: f * u
        } : {
            x: f * u,
            y: p * c
        }
    }
    var ze = function(t) {
            return t === void 0 && (t = 0), {
                name: "offset",
                options: t,
                async fn(e) {
                    var n, o;
                    let {
                        x: i,
                        y: r,
                        placement: a,
                        middlewareData: s
                    } = e, l = await Zn(e, t);
                    return a === ((n = s.offset) == null ? void 0 : n.placement) && (o = s.arrow) != null && o.alignmentOffset ? {} : {
                        x: i + l.x,
                        y: r + l.y,
                        data: {
                            ...l,
                            placement: a
                        }
                    }
                }
            }
        },
        We = function(t) {
            return t === void 0 && (t = {}), {
                name: "shift",
                options: t,
                async fn(e) {
                    let {
                        x: n,
                        y: o,
                        placement: i
                    } = e, {
                        mainAxis: r = !0,
                        crossAxis: a = !1,
                        limiter: s = {
                            fn: w => {
                                let {
                                    x: A,
                                    y: S
                                } = w;
                                return {
                                    x: A,
                                    y: S
                                }
                            }
                        },
                        ...l
                    } = ct(t, e), u = {
                        x: n,
                        y: o
                    }, c = await Kt(e, l), d = it(tt(i)), f = jt(d), p = u[f], h = u[d];
                    if (r) {
                        let w = f === "y" ? "top" : "left",
                            A = f === "y" ? "bottom" : "right",
                            S = p + c[w],
                            x = p - c[A];
                        p = se(S, p, x)
                    }
                    if (a) {
                        let w = d === "y" ? "top" : "left",
                            A = d === "y" ? "bottom" : "right",
                            S = h + c[w],
                            x = h - c[A];
                        h = se(S, h, x)
                    }
                    let b = s.fn({
                        ...e,
                        [f]: p,
                        [d]: h
                    });
                    return {
                        ...b,
                        data: {
                            x: b.x - n,
                            y: b.y - o
                        }
                    }
                }
            }
        },
        je = function(t) {
            return t === void 0 && (t = {}), {
                options: t,
                fn(e) {
                    let {
                        x: n,
                        y: o,
                        placement: i,
                        rects: r,
                        middlewareData: a
                    } = e, {
                        offset: s = 0,
                        mainAxis: l = !0,
                        crossAxis: u = !0
                    } = ct(t, e), c = {
                        x: n,
                        y: o
                    }, d = it(i), f = jt(d), p = c[f], h = c[d], b = ct(s, e), w = typeof b == "number" ? {
                        mainAxis: b,
                        crossAxis: 0
                    } : {
                        mainAxis: 0,
                        crossAxis: 0,
                        ...b
                    };
                    if (l) {
                        let x = f === "y" ? "height" : "width",
                            I = r.reference[f] - r.floating[x] + w.mainAxis,
                            M = r.reference[f] + r.reference[x] - w.mainAxis;
                        p < I ? p = I : p > M && (p = M)
                    }
                    if (u) {
                        var A, S;
                        let x = f === "y" ? "width" : "height",
                            I = ["top", "left"].includes(tt(i)),
                            M = r.reference[d] - r.floating[x] + (I && ((A = a.offset) == null ? void 0 : A[d]) || 0) + (I ? 0 : w.crossAxis),
                            _ = r.reference[d] + r.reference[x] + (I ? 0 : ((S = a.offset) == null ? void 0 : S[d]) || 0) - (I ? w.crossAxis : 0);
                        h < M ? h = M : h > _ && (h = _)
                    }
                    return {
                        [f]: p,
                        [d]: h
                    }
                }
            }
        },
        Ke = function(t) {
            return t === void 0 && (t = {}), {
                name: "size",
                options: t,
                async fn(e) {
                    let {
                        placement: n,
                        rects: o,
                        platform: i,
                        elements: r
                    } = e, {
                        apply: a = () => {},
                        ...s
                    } = ct(t, e), l = await Kt(e, s), u = tt(n), c = At(n), d = it(n) === "y", {
                        width: f,
                        height: p
                    } = o.floating, h, b;
                    u === "top" || u === "bottom" ? (h = u, b = c === (await (i.isRTL == null ? void 0 : i.isRTL(r.floating)) ? "start" : "end") ? "left" : "right") : (b = u, h = c === "end" ? "top" : "bottom");
                    let w = p - l.top - l.bottom,
                        A = f - l.left - l.right,
                        S = Z(p - l[h], w),
                        x = Z(f - l[b], A),
                        I = !e.middlewareData.shift,
                        M = S,
                        _ = x;
                    if (d ? _ = c || I ? Z(x, A) : A : M = c || I ? Z(S, w) : w, I && !c) {
                        let m = z(l.left, 0),
                            g = z(l.right, 0),
                            H = z(l.top, 0),
                            T = z(l.bottom, 0);
                        d ? _ = f - 2 * (m !== 0 || g !== 0 ? m + g : z(l.left, l.right)) : M = p - 2 * (H !== 0 || T !== 0 ? H + T : z(l.top, l.bottom))
                    }
                    await a({
                        ...e,
                        availableWidth: _,
                        availableHeight: M
                    });
                    let R = await i.getDimensions(r.floating);
                    return f !== R.width || p !== R.height ? {
                        reset: {
                            rects: !0
                        }
                    } : {}
                }
            }
        };

    function mt(t) {
        return Ge(t) ? (t.nodeName || "").toLowerCase() : "#document"
    }

    function j(t) {
        var e;
        return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window
    }

    function et(t) {
        var e;
        return (e = (Ge(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement
    }

    function Ge(t) {
        return t instanceof Node || t instanceof j(t).Node
    }

    function K(t) {
        return t instanceof Element || t instanceof j(t).Element
    }

    function Q(t) {
        return t instanceof HTMLElement || t instanceof j(t).HTMLElement
    }

    function Ye(t) {
        return typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof j(t).ShadowRoot
    }

    function Et(t) {
        let {
            overflow: e,
            overflowX: n,
            overflowY: o,
            display: i
        } = Y(t);
        return /auto|scroll|overlay|hidden|clip/.test(e + o + n) && !["inline", "contents"].includes(i)
    }

    function Qe(t) {
        return ["table", "td", "th"].includes(mt(t))
    }

    function Ot(t) {
        return [":popover-open", ":modal"].some(e => {
            try {
                return t.matches(e)
            } catch {
                return !1
            }
        })
    }

    function Yt(t) {
        let e = Gt(),
            n = K(t) ? Y(t) : t;
        return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some(o => (n.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some(o => (n.contain || "").includes(o))
    }

    function Je(t) {
        let e = rt(t);
        for (; Q(e) && !pt(e);) {
            if (Yt(e)) return e;
            if (Ot(e)) return null;
            e = rt(e)
        }
        return null
    }

    function Gt() {
        return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none")
    }

    function pt(t) {
        return ["html", "body", "#document"].includes(mt(t))
    }

    function Y(t) {
        return j(t).getComputedStyle(t)
    }

    function _t(t) {
        return K(t) ? {
            scrollLeft: t.scrollLeft,
            scrollTop: t.scrollTop
        } : {
            scrollLeft: t.scrollX,
            scrollTop: t.scrollY
        }
    }

    function rt(t) {
        if (mt(t) === "html") return t;
        let e = t.assignedSlot || t.parentNode || Ye(t) && t.host || et(t);
        return Ye(e) ? e.host : e
    }

    function Xe(t) {
        let e = rt(t);
        return pt(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : Q(e) && Et(e) ? e : Xe(e)
    }

    function wt(t, e, n) {
        var o;
        e === void 0 && (e = []), n === void 0 && (n = !0);
        let i = Xe(t),
            r = i === ((o = t.ownerDocument) == null ? void 0 : o.body),
            a = j(i);
        if (r) {
            let s = Qt(a);
            return e.concat(a, a.visualViewport || [], Et(i) ? i : [], s && n ? wt(s) : [])
        }
        return e.concat(i, wt(i, [], n))
    }

    function Qt(t) {
        return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null
    }

    function en(t) {
        let e = Y(t),
            n = parseFloat(e.width) || 0,
            o = parseFloat(e.height) || 0,
            i = Q(t),
            r = i ? t.offsetWidth : n,
            a = i ? t.offsetHeight : o,
            s = Mt(n) !== r || Mt(o) !== a;
        return s && (n = r, o = a), {
            width: n,
            height: o,
            $: s
        }
    }

    function ue(t) {
        return K(t) ? t : t.contextElement
    }

    function vt(t) {
        let e = ue(t);
        if (!Q(e)) return ot(1);
        let n = e.getBoundingClientRect(),
            {
                width: o,
                height: i,
                $: r
            } = en(e),
            a = (r ? Mt(n.width) : n.width) / o,
            s = (r ? Mt(n.height) : n.height) / i;
        return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
            x: a,
            y: s
        }
    }
    var to = ot(0);

    function nn(t) {
        let e = j(t);
        return !Gt() || !e.visualViewport ? to : {
            x: e.visualViewport.offsetLeft,
            y: e.visualViewport.offsetTop
        }
    }

    function eo(t, e, n) {
        return e === void 0 && (e = !1), !n || e && n !== j(t) ? !1 : e
    }

    function gt(t, e, n, o) {
        e === void 0 && (e = !1), n === void 0 && (n = !1);
        let i = t.getBoundingClientRect(),
            r = ue(t),
            a = ot(1);
        e && (o ? K(o) && (a = vt(o)) : a = vt(t));
        let s = eo(r, n, o) ? nn(r) : ot(0),
            l = (i.left + s.x) / a.x,
            u = (i.top + s.y) / a.y,
            c = i.width / a.x,
            d = i.height / a.y;
        if (r) {
            let f = j(r),
                p = o && K(o) ? j(o) : o,
                h = f,
                b = Qt(h);
            for (; b && o && p !== h;) {
                let w = vt(b),
                    A = b.getBoundingClientRect(),
                    S = Y(b),
                    x = A.left + (b.clientLeft + parseFloat(S.paddingLeft)) * w.x,
                    I = A.top + (b.clientTop + parseFloat(S.paddingTop)) * w.y;
                l *= w.x, u *= w.y, c *= w.x, d *= w.y, l += x, u += I, h = j(b), b = Qt(h)
            }
        }
        return ft({
            width: c,
            height: d,
            x: l,
            y: u
        })
    }

    function no(t) {
        let {
            elements: e,
            rect: n,
            offsetParent: o,
            strategy: i
        } = t, r = i === "fixed", a = et(o), s = e ? Ot(e.floating) : !1;
        if (o === a || s && r) return n;
        let l = {
                scrollLeft: 0,
                scrollTop: 0
            },
            u = ot(1),
            c = ot(0),
            d = Q(o);
        if ((d || !d && !r) && ((mt(o) !== "body" || Et(a)) && (l = _t(o)), Q(o))) {
            let f = gt(o);
            u = vt(o), c.x = f.x + o.clientLeft, c.y = f.y + o.clientTop
        }
        return {
            width: n.width * u.x,
            height: n.height * u.y,
            x: n.x * u.x - l.scrollLeft * u.x + c.x,
            y: n.y * u.y - l.scrollTop * u.y + c.y
        }
    }

    function oo(t) {
        return Array.from(t.getClientRects())
    }

    function on(t) {
        return gt(et(t)).left + _t(t).scrollLeft
    }

    function io(t) {
        let e = et(t),
            n = _t(t),
            o = t.ownerDocument.body,
            i = z(e.scrollWidth, e.clientWidth, o.scrollWidth, o.clientWidth),
            r = z(e.scrollHeight, e.clientHeight, o.scrollHeight, o.clientHeight),
            a = -n.scrollLeft + on(t),
            s = -n.scrollTop;
        return Y(o).direction === "rtl" && (a += z(e.clientWidth, o.clientWidth) - i), {
            width: i,
            height: r,
            x: a,
            y: s
        }
    }

    function ro(t, e) {
        let n = j(t),
            o = et(t),
            i = n.visualViewport,
            r = o.clientWidth,
            a = o.clientHeight,
            s = 0,
            l = 0;
        if (i) {
            r = i.width, a = i.height;
            let u = Gt();
            (!u || u && e === "fixed") && (s = i.offsetLeft, l = i.offsetTop)
        }
        return {
            width: r,
            height: a,
            x: s,
            y: l
        }
    }

    function ao(t, e) {
        let n = gt(t, !0, e === "fixed"),
            o = n.top + t.clientTop,
            i = n.left + t.clientLeft,
            r = Q(t) ? vt(t) : ot(1),
            a = t.clientWidth * r.x,
            s = t.clientHeight * r.y,
            l = i * r.x,
            u = o * r.y;
        return {
            width: a,
            height: s,
            x: l,
            y: u
        }
    }

    function Ze(t, e, n) {
        let o;
        if (e === "viewport") o = ro(t, n);
        else if (e === "document") o = io(et(t));
        else if (K(e)) o = ao(e, n);
        else {
            let i = nn(t);
            o = {
                ...e,
                x: e.x - i.x,
                y: e.y - i.y
            }
        }
        return ft(o)
    }

    function rn(t, e) {
        let n = rt(t);
        return n === e || !K(n) || pt(n) ? !1 : Y(n).position === "fixed" || rn(n, e)
    }

    function so(t, e) {
        let n = e.get(t);
        if (n) return n;
        let o = wt(t, [], !1).filter(s => K(s) && mt(s) !== "body"),
            i = null,
            r = Y(t).position === "fixed",
            a = r ? rt(t) : t;
        for (; K(a) && !pt(a);) {
            let s = Y(a),
                l = Yt(a);
            !l && s.position === "fixed" && (i = null), (r ? !l && !i : !l && s.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || Et(a) && !l && rn(t, a)) ? o = o.filter(c => c !== a) : i = s, a = rt(a)
        }
        return e.set(t, o), o
    }

    function lo(t) {
        let {
            element: e,
            boundary: n,
            rootBoundary: o,
            strategy: i
        } = t, a = [...n === "clippingAncestors" ? Ot(e) ? [] : so(e, this._c) : [].concat(n), o], s = a[0], l = a.reduce((u, c) => {
            let d = Ze(e, c, i);
            return u.top = z(d.top, u.top), u.right = Z(d.right, u.right), u.bottom = Z(d.bottom, u.bottom), u.left = z(d.left, u.left), u
        }, Ze(e, s, i));
        return {
            width: l.right - l.left,
            height: l.bottom - l.top,
            x: l.left,
            y: l.top
        }
    }

    function co(t) {
        let {
            width: e,
            height: n
        } = en(t);
        return {
            width: e,
            height: n
        }
    }

    function uo(t, e, n) {
        let o = Q(e),
            i = et(e),
            r = n === "fixed",
            a = gt(t, !0, r, e),
            s = {
                scrollLeft: 0,
                scrollTop: 0
            },
            l = ot(0);
        if (o || !o && !r)
            if ((mt(e) !== "body" || Et(i)) && (s = _t(e)), o) {
                let d = gt(e, !0, r, e);
                l.x = d.x + e.clientLeft, l.y = d.y + e.clientTop
            } else i && (l.x = on(i));
        let u = a.left + s.scrollLeft - l.x,
            c = a.top + s.scrollTop - l.y;
        return {
            x: u,
            y: c,
            width: a.width,
            height: a.height
        }
    }

    function de(t) {
        return Y(t).position === "static"
    }

    function tn(t, e) {
        return !Q(t) || Y(t).position === "fixed" ? null : e ? e(t) : t.offsetParent
    }

    function an(t, e) {
        let n = j(t);
        if (Ot(t)) return n;
        if (!Q(t)) {
            let i = rt(t);
            for (; i && !pt(i);) {
                if (K(i) && !de(i)) return i;
                i = rt(i)
            }
            return n
        }
        let o = tn(t, e);
        for (; o && Qe(o) && de(o);) o = tn(o, e);
        return o && pt(o) && de(o) && !Yt(o) ? n : o || Je(t) || n
    }
    var fo = async function(t) {
        let e = this.getOffsetParent || an,
            n = this.getDimensions,
            o = await n(t.floating);
        return {
            reference: uo(t.reference, await e(t.floating), t.strategy),
            floating: {
                x: 0,
                y: 0,
                width: o.width,
                height: o.height
            }
        }
    };

    function mo(t) {
        return Y(t).direction === "rtl"
    }
    var po = {
        convertOffsetParentRelativeRectToViewportRelativeRect: no,
        getDocumentElement: et,
        getClippingRect: lo,
        getOffsetParent: an,
        getElementRects: fo,
        getClientRects: oo,
        getDimensions: co,
        getScale: vt,
        isElement: K,
        isRTL: mo
    };

    function go(t, e) {
        let n = null,
            o, i = et(t);

        function r() {
            var s;
            clearTimeout(o), (s = n) == null || s.disconnect(), n = null
        }

        function a(s, l) {
            s === void 0 && (s = !1), l === void 0 && (l = 1), r();
            let {
                left: u,
                top: c,
                width: d,
                height: f
            } = t.getBoundingClientRect();
            if (s || e(), !d || !f) return;
            let p = Ht(c),
                h = Ht(i.clientWidth - (u + d)),
                b = Ht(i.clientHeight - (c + f)),
                w = Ht(u),
                S = {
                    rootMargin: -p + "px " + -h + "px " + -b + "px " + -w + "px",
                    threshold: z(0, Z(1, l)) || 1
                },
                x = !0;

            function I(M) {
                let _ = M[0].intersectionRatio;
                if (_ !== l) {
                    if (!x) return a();
                    _ ? a(!1, _) : o = setTimeout(() => {
                        a(!1, 1e-7)
                    }, 1e3)
                }
                x = !1
            }
            try {
                n = new IntersectionObserver(I, {
                    ...S,
                    root: i.ownerDocument
                })
            } catch {
                n = new IntersectionObserver(I, S)
            }
            n.observe(t)
        }
        return a(!0), r
    }

    function sn(t, e, n, o) {
        o === void 0 && (o = {});
        let {
            ancestorScroll: i = !0,
            ancestorResize: r = !0,
            elementResize: a = typeof ResizeObserver == "function",
            layoutShift: s = typeof IntersectionObserver == "function",
            animationFrame: l = !1
        } = o, u = ue(t), c = i || r ? [...u ? wt(u) : [], ...wt(e)] : [];
        c.forEach(A => {
            i && A.addEventListener("scroll", n, {
                passive: !0
            }), r && A.addEventListener("resize", n)
        });
        let d = u && s ? go(u, n) : null,
            f = -1,
            p = null;
        a && (p = new ResizeObserver(A => {
            let [S] = A;
            S && S.target === u && p && (p.unobserve(e), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
                var x;
                (x = p) == null || x.observe(e)
            })), n()
        }), u && !l && p.observe(u), p.observe(e));
        let h, b = l ? gt(t) : null;
        l && w();

        function w() {
            let A = gt(t);
            b && (A.x !== b.x || A.y !== b.y || A.width !== b.width || A.height !== b.height) && n(), b = A, h = requestAnimationFrame(w)
        }
        return n(), () => {
            var A;
            c.forEach(S => {
                i && S.removeEventListener("scroll", n), r && S.removeEventListener("resize", n)
            }), d?.(), (A = p) == null || A.disconnect(), p = null, l && cancelAnimationFrame(h)
        }
    }
    var ln = ze;
    var cn = We,
        dn = Ue,
        un = Ke;
    var fn = je,
        mn = (t, e, n) => {
            let o = new Map,
                i = {
                    platform: po,
                    ...n
                },
                r = {
                    ...i.platform,
                    _c: o
                };
            return Ve(t, e, {
                ...i,
                platform: r
            })
        };
    var pn = t => {
            let e = t.querySelectorAll("iframe.tiktok__autoplay");
            Array.from(e).forEach(n => {
                let o = n.getAttribute("src") ?? "";
                yn(o, n)
            })
        },
        gn = t => {
            let e = t.querySelectorAll(".instant-video-fill__controls, .video-fill__controls");
            Array.from(e).forEach(n => {
                let o = n.closest(".instant-video-fill__wrapper, .video-fill__wrapper"),
                    i = o?.querySelector("video");
                o && i && n.addEventListener("click", () => {
                    i.paused ? (i.play(), o.setAttribute("data-paused", "false")) : (i.pause(), o.setAttribute("data-paused", "true"))
                }, {
                    signal: window.Instant.eventAbortController.signal
                })
            })
        },
        yn = (t, e) => {
            let n = t.split("/").pop();
            e.setAttribute("name", `__tt_embed__${n}`), window.addEventListener("message", o => {
                try {
                    let i = JSON.parse(o.data);
                    i.height && document.querySelector(`[name="${i.signalSource}"]`)?.closest(".instant-video__container, .video__container")?.setAttribute("style", `height:${i.height}px;width:325px;border-radius:8px 8px 8px 8px;overflow:hidden`)
                } catch {}
            }, {
                signal: window.Instant.eventAbortController.signal
            })
        },
        hn = t => {
            let e = t.querySelectorAll("article.instant-video__wrapper, article.video__wrapper");
            Array.from(e).forEach(o => {
                o.addEventListener("click", () => {
                    if (!o.querySelector("iframe") && o.getAttribute("data-type") !== "external") {
                        let i = o.getAttribute("data-src") ?? "",
                            r = o.getAttribute("data-title") ?? "",
                            a = document.createElement("iframe");
                        a.className = "instant-video__iframe", a.setAttribute("src", i), a.setAttribute("title", r), a.setAttribute("frameborder", "0"), a.setAttribute("allow", "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"), a.setAttribute("allowfullscreen", "allowfullscreen"), o.style.setProperty("background-image", "none"), i?.includes("tiktok") && yn(i, a), o.appendChild(a)
                    } else if (!o.querySelector("video") && o.getAttribute("data-type") === "external") {
                        let i = o.getAttribute("data-src") ?? "",
                            r = document.createElement("video");
                        r.className = "instant-video__player", r.setAttribute("autoplay", "true"), r.setAttribute("controls", "true"), r.setAttribute("playsInline", "true"), r.setAttribute("src", i), o.style.setProperty("background-image", "none"), o.appendChild(r)
                    }
                }, {
                    signal: window.Instant.eventAbortController.signal
                })
            });
            let n = t.querySelectorAll(".instant-video-fill__wrapper");
            Array.from(n).forEach(o => {
                let i = o.querySelector("video");
                i && i.play().then(() => {}).catch(() => {
                    let r = o.querySelector(".instant-video-fill__overlay"),
                        a = i.getAttribute("poster") ?? "",
                        s = document.createElement("img");
                    s.setAttribute("src", a), s.className = "instant-video-fill__video", r ? o.insertBefore(s, r) : o.append(s)
                })
            })
        },
        Jt = t => {
            t.querySelectorAll(".instant-video__container").forEach(e => {
                let n = e.querySelector("video");
                if (n) {
                    n.autoplay ? n.muted = !0 : n.pause();
                    return
                }
                let o = e.querySelector("iframe");
                o?.src?.startsWith("https://www.youtube.com/") ? o.contentWindow?.postMessage(JSON.stringify({
                    event: "command",
                    func: o.src.includes("autoplay=1") ? "mute" : "playVideo",
                    args: []
                }), "*") : o?.src?.startsWith("https://player.vimeo.com/") && o.contentWindow?.postMessage(JSON.stringify(o.src.includes("autoplay=1") ? {
                    method: "setVolume",
                    value: 0
                } : {
                    method: "pause"
                }), "*")
            })
        };
    var G = (t, e = !1) => {
            let n = t.getAttribute("data-instant-overlay-pointer-events");
            if (t.getAttribute("data-state") === "open") {
                if (n === "AUTO") {
                    let i = document.querySelectorAll('[data-instant-type="overlay"]');
                    if (!Array.from(i).find(r => r.id !== P(t) && r.getAttribute("data-state") === "open" && r.getAttribute("data-instant-overlay-pointer-events") === "AUTO")) {
                        let r = window.__instantOverlayBodyOverflow;
                        document.body.style.overflow = r || "", delete window.__instantOverlayBodyOverflow
                    }
                }(e && n === "AUTO" || !e) && (t.setAttribute("data-state", "closed"), Jt(t))
            } else {
                if (n === "AUTO" && typeof window.__instantOverlayBodyOverflow > "u") {
                    let i = document.body.style.overflow;
                    window.__instantOverlayBodyOverflow = i, document.body.style.overflow = "hidden"
                }
                t.setAttribute("data-state", "open")
            }
        },
        fe = (t, e) => {
            let n = t.getAttribute("data-instant-action-id"),
                o;
            return n ? o = document.querySelector(`.i${n}`) : o = t.closest(`[data-instant-type="${e}"]`), o
        },
        Tt = (t, e, n, o) => {
            let i = fe(t, e);
            if (i)
                if (e === "overlay") G(i);
                else {
                    let r = i.parentElement;
                    if (!r) return;
                    let a = t.getAttribute("data-instant-action-id"),
                        s = document.querySelectorAll(`[data-instant-action-id="${a}"][data-instant-state="active"]`),
                        l = r.getAttribute("data-state"),
                        u = n || (l === "open" ? "close" : "open");
                    s.length > 0 && s.forEach(d => {
                        d !== t && (d.setAttribute("data-instant-state", "inactive"), d.style.pointerEvents = "")
                    });
                    let c = document.body;
                    c.getAttribute("safe-polygon") || (c.style.pointerEvents = "none", c.setAttribute("safe-polygon", ""), t.style.pointerEvents = "auto", r.style.pointerEvents = "auto"), me(i, t, u, o)
                }
        },
        bn = t => {
            let e = t.querySelectorAll('[data-instant-type="overlay"]');
            Array.from(e).forEach(n => {
                let o = n.getAttribute("data-instant-overlay-scroll-offset"),
                    i = n.getAttribute("data-instant-overlay-delay"),
                    r = n.getAttribute("data-instant-overlay-is-close-persistent") === "true",
                    a = n.getAttribute("data-instant-overlay-pointer-events"),
                    s = window?.Shopify?.designMode,
                    l, u = `instant-overlay-inner-${P(n)}`;
                if (r && !s) {
                    let c = sessionStorage.getItem(u),
                        d = n.innerHTML;
                    d !== c && (sessionStorage.setItem(u, d), l = !0)
                } else l = !0;
                if (l && !s) {
                    if (o) {
                        let c = Number(o),
                            d = !1,
                            f = () => {
                                if (window.scrollY < c) {
                                    d = !1;
                                    return
                                }
                                n.getAttribute("data-state") === "open" || G(n), d = !0
                            },
                            p = () => {
                                d || (window.requestAnimationFrame(f), d = !0)
                            };
                        window.addEventListener("scroll", p, {
                            signal: window.Instant.eventAbortController.signal
                        })
                    } else if (i) {
                        let c = Number(i);
                        setTimeout(() => {
                            n.getAttribute("data-state") === "open" || G(n)
                        }, c)
                    }
                }
                a === "AUTO" && n.addEventListener("pointerdown", c => {
                    c.target === c.currentTarget && G(n, !0)
                }, {
                    signal: window.Instant.eventAbortController.signal
                })
            })
        };
    var An = (t, e) => {
            let [n, o] = t, i = !1, r = e.length;
            for (let a = 0, s = r - 1; a < r; s = a++) {
                let [l, u] = e[a] || [0, 0], [c, d] = e[s] || [0, 0];
                u >= o != d >= o && n <= (c - l) * (o - u) / (d - u) + l && (i = !i)
            }
            return i
        },
        yo = (t, e) => t[0] >= e.x && t[0] <= e.x + e.width && t[1] >= e.y && t[1] <= e.y + e.height,
        pe = (t, e) => {
            if (!t || !e) return !1;
            let n = e.getRootNode?.();
            if (t.contains(e)) return !0;
            if (n && n instanceof ShadowRoot) {
                let o = e;
                for (; o;) {
                    if (t === o) return !0;
                    o = o.parentNode || o.host
                }
            }
            return !1
        },
        ho = t => "composedPath" in t ? t.composedPath()[0] : t.target,
        bo = (t = {}) => {
            let {
                buffer: e = .5
            } = t, n, o = !1, i = null, r = null, a = performance.now();

            function s(u, c) {
                let d = performance.now(),
                    f = d - a;
                if (i === null || r === null || f === 0) return i = u, r = c, a = d, null;
                let p = u - i,
                    h = c - r,
                    w = Math.sqrt(p * p + h * h) / f;
                return i = u, r = c, a = d, w
            }
            return ({
                x: u,
                y: c,
                placement: d,
                elements: f,
                onClose: p
            }) => function(b) {
                function w() {
                    clearTimeout(n), p()
                }
                if (clearTimeout(n), !f.domReference || !f.floating || d == null || u == null || c == null) return;
                let {
                    clientX: A,
                    clientY: S
                } = b, x = [A, S], I = ho(b), M = b.type === "mouseleave", _ = pe(f.floating, I), R = pe(f.domReference, I), m = f.domReference.getBoundingClientRect(), g = f.floating.getBoundingClientRect(), H = d.split("-")[0], T = u > g.right - g.width / 2, O = c > g.bottom - g.height / 2, v = yo(x, m), q = g.width > m.width, k = g.height > m.height, B = (q ? m : g).left, F = (q ? m : g).right, V = (k ? m : g).top, U = (k ? m : g).bottom;
                if (_ && (o = !0, !M)) return;
                if (R && (o = !1), R && !M) {
                    o = !0;
                    return
                }
                if (M && b.relatedTarget instanceof Element && pe(f.floating, b.relatedTarget) || f.floating.querySelectorAll('.instant-dropdown--wrapper[data-state="open"]').length > 0) return;
                let dt = [];
                switch (H) {
                    case "top":
                        dt = [
                            [B, m.top + 1],
                            [B, g.bottom - 1],
                            [F, g.bottom - 1],
                            [F, m.top + 1]
                        ];
                        break;
                    case "bottom":
                        dt = [
                            [B, g.top + 1],
                            [B, m.bottom - 1],
                            [F, m.bottom - 1],
                            [F, g.top + 1]
                        ];
                        break;
                    case "left":
                        dt = [
                            [g.right - 1, U],
                            [g.right - 1, V],
                            [m.left + 1, V],
                            [m.left + 1, U]
                        ];
                        break;
                    case "right":
                        dt = [
                            [m.right - 1, U],
                            [m.right - 1, V],
                            [g.left + 1, V],
                            [g.left + 1, U]
                        ];
                        break
                }

                function Zt([N, $]) {
                    switch (H) {
                        case "top": {
                            let J = [q ? N + e / 2 : T ? N + e * 4 : N - e * 4, $ + e + 1],
                                nt = [q ? N - e / 2 : T ? N + e * 4 : N - e * 4, $ + e + 1],
                                at = [
                                    [g.left, T || q ? g.bottom - e : g.top],
                                    [g.right, T ? q ? g.bottom - e : g.top : g.bottom - e]
                                ];
                            return [J, nt, ...at]
                        }
                        case "bottom": {
                            let J = [q ? N + e / 2 : T ? N + e * 4 : N - e * 4, $ - e],
                                nt = [q ? N - e / 2 : T ? N + e * 4 : N - e * 4, $ - e],
                                at = [
                                    [g.left, T || q ? g.top + e : g.bottom],
                                    [g.right, T ? q ? g.top + e : g.bottom : g.top + e]
                                ];
                            return [J, nt, ...at]
                        }
                        case "left": {
                            let J = [N + e + 1, k ? $ + e / 2 : O ? $ + e * 4 : $ - e * 4],
                                nt = [N + e + 1, k ? $ - e / 2 : O ? $ + e * 4 : $ - e * 4];
                            return [...[
                                [O || k ? g.right - e : g.left, g.top],
                                [O ? k ? g.right - e : g.left : g.right - e, g.bottom]
                            ], J, nt]
                        }
                        case "right": {
                            let J = [N - e, k ? $ + e / 2 : O ? $ + e * 4 : $ - e * 4],
                                nt = [N - e, k ? $ - e / 2 : O ? $ + e * 4 : $ - e * 4],
                                at = [
                                    [O || k ? g.left + e : g.right, g.top],
                                    [O ? k ? g.left + e : g.right : g.left + e, g.bottom]
                                ];
                            return [J, nt, ...at]
                        }
                    }
                }
                if (!An([A, S], dt)) {
                    if (o && !v) return w();
                    if (!M) {
                        let N = s(b.clientX, b.clientY);
                        if (N !== null && N < .1) return w()
                    }
                    An([A, S], Zt([u, c])) ? o || (n = window.setTimeout(w, 40)) : w()
                }
            }
        },
        Rt = (t, e, n) => {
            let o = document.body,
                i = n ? n === "close" : e.getAttribute("data-state") === "open",
                r = a => {
                    if (e?.getAttribute("data-state") === "open" && !e.children[0].contains(a.target)) {
                        let l = e.querySelector('[data-instant-type="dropdown"]'),
                            u = document.querySelectorAll(`[data-instant-action-id="${xt(P(l))}"][data-instant-state="active"]`);
                        Rt(u, e, "close")
                    }
                };
            if (i) o.hasAttribute("safe-polygon") && !o.querySelector('.instant-dropdown--wrapper[data-state="open"] .instant-dropdown--wrapper[data-state="open"]') && (o.style.pointerEvents = "", o.removeAttribute("safe-polygon"), e.style.pointerEvents = ""), e.setAttribute("data-state", "closed"), t.forEach(s => {
                s.setAttribute("data-instant-state", "inactive"), s.style.pointerEvents = ""
            }), e.cleanup && (e.cleanup(), delete e.cleanup), e.querySelectorAll('.instant-dropdown--wrapper[data-state="open"] > [data-instant-type="dropdown"]').forEach(s => {
                let l = s.parentElement,
                    u = document.querySelectorAll(`[data-instant-action-id="${xt(P(s))}"][data-instant-state="active"]`);
                Rt(u, l, "close")
            }), Jt(e), document.removeEventListener("click", r);
            else {
                if (e.setAttribute("data-state", "open"), t.forEach(a => a.setAttribute("data-instant-state", "active")), !e.cleanup) {
                    let a = e.querySelector('[data-instant-type="dropdown"]');
                    a && t[0] && me(a, t[0], "open")
                }
                document.addEventListener("click", r, {
                    signal: window.Instant.eventAbortController.signal
                })
            }
        },
        Ao = (t, e) => {
            let n = {
                    x: e.x,
                    y: e.y
                },
                o = {
                    x: t.x,
                    y: t.y
                },
                i = {
                    x: e.x + e.width,
                    y: e.y + e.height
                },
                r = {
                    x: t.x + t.width,
                    y: t.y + t.height
                };
            return n.x < o.x && i.x < o.x ? "left" : n.x > r.x && i.x > r.x ? "right" : n.y < o.y && i.y < o.y ? "top" : "bottom"
        },
        wo = (t, e, n, o, i, r, a) => {
            mn(t, e, {
                strategy: "fixed",
                placement: o,
                middleware: [ln(i), cn({
                    limiter: fn(),
                    boundary: []
                }), dn({
                    fallbackStrategy: "initialPlacement",
                    fallbackPlacements: ["bottom", "right", "left", "top"],
                    boundary: []
                }), un({
                    apply({
                        rects: s,
                        elements: l
                    }) {
                        Object.assign(l.floating.style, {
                            minWidth: `${s.reference.width}px`,
                            minHeight: `${s.reference.height}px`
                        }), l.floating.style.setProperty("--instant-reference-width", `${s.reference.width}px`), l.floating.style.setProperty("--instant-reference-height", `${s.reference.height}px`)
                    }
                })]
            }).then(({
                x: s,
                y: l,
                placement: u
            }) => {
                let c = Ao(n.getBoundingClientRect(), e.getBoundingClientRect());
                if (Object.assign(e.style, {
                        left: `${s}px`,
                        top: `${l}px`
                    }), e.setAttribute("data-instant-dropdown-placement", u), r) {
                    let d = bo(),
                        f = p => {
                            e.getAttribute("data-state") === "open" ? d({
                                elements: {
                                    floating: e,
                                    domReference: n
                                },
                                x: s,
                                y: l,
                                placement: c,
                                onClose: () => {
                                    document.removeEventListener("mousemove", f), Rt([n], e, "close")
                                }
                            })(p) : document.removeEventListener("mousemove", f)
                        };
                    document.addEventListener("mousemove", f, {
                        signal: window.Instant.eventAbortController.signal
                    })
                } else Rt([n], e, a)
            })
        },
        me = (t, e, n, o = !1) => {
            let i = t.getAttribute("data-instant-dropdown-placement"),
                r = t.getAttribute("data-instant-dropdown-offset"),
                a = Number(r) || 0,
                s = t.parentNode,
                l = s.parentNode;
            return s.cleanup && s.cleanup(), s.cleanup = sn(l, s, () => {
                wo(l, s, e, i, a, o, n)
            }), s.cleanup
        },
        wn = t => {
            let e = t.querySelectorAll('[data-instant-type="dropdown"]');
            Array.from(e).forEach(n => {
                let o = n.querySelectorAll('*[data-instant-action-type]:not([data-instant-action-on-hover]):not([data-instant-action-type="open-dropdown"])'),
                    i = n.parentElement,
                    a = window.getComputedStyle(n).zIndex;
                i && (i.style.setProperty("z-index", a), n.style.setProperty("z-index", "auto")), Array.from(o).forEach(s => {
                    s.addEventListener("click", l => {
                        l.preventDefault(), l.stopPropagation();
                        let u = l.currentTarget;
                        if (!u || !(u instanceof HTMLElement)) return null;
                        let c = document.querySelectorAll(`[data-instant-action-id="${xt(P(n))}"][data-instant-state="active"]`);
                        Rt(c, i, "close")
                    }, {
                        signal: window.Instant.eventAbortController.signal
                    })
                })
            })
        },
        En = t => {
            let e = t.querySelectorAll('[data-instant-action-type="open-dropdown"][data-instant-action-on-hover]');
            Array.from(e).forEach(n => {
                let i = fe(n, "dropdown")?.parentNode;
                i && (n.addEventListener("mouseenter", () => {
                    let r = document.body;
                    r.getAttribute("safe-polygon") || (r.style.pointerEvents = "none", r.setAttribute("safe-polygon", ""), n.style.pointerEvents = "auto", i.style.pointerEvents = "auto"), Tt(n, "dropdown", "open")
                }, {
                    signal: window.Instant.eventAbortController.signal
                }), n.addEventListener("mouseleave", () => {
                    Tt(n, "dropdown", "close", !0)
                }, {
                    signal: window.Instant.eventAbortController.signal
                }), n.addEventListener("click", r => {
                    r.preventDefault(), r.stopPropagation()
                }, {
                    signal: window.Instant.eventAbortController.signal
                }))
            })
        };
    var Xt = t => {
        let e = document.querySelector('.__instant[data-instant-layout="CART"]');
        if (!e) {
            console.warn("Instant cart not found");
            return
        }
        let n = [e.getAttribute("data-section-id")];
        return fetch(`${window.Shopify?.routes?.root}cart/change.js`, {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                ...t,
                sections: n
            }),
            method: "POST"
        }).then(o => {
            if (!o.ok) throw new Error;
            return o.json().then(({
                items: i,
                sections: r
            }) => qt([e], r, {
                resetCountdowns: !0
            }))
        }).catch(o => {
            console.error("Error updating line item", o)
        })
    };
    var Eo = t => {
            let e = document.getElementById(`i${t}`);
            e && e.scrollIntoView({
                behavior: "smooth",
                block: "start"
            })
        },
        vo = t => "checkVisibility" in t ? !t.checkVisibility() : t.offsetParent === null,
        St = (t, e) => {
            e ? (t.classList.add("instant-loading"), t.style.setProperty("cursor", "wait"), t.setAttribute("disabled", "disabled")) : (t.classList.remove("instant-loading"), t.style.removeProperty("cursor"), t.removeAttribute("disabled"))
        },
        To = kt(t => {
            t.dispatchEvent(new Event("change", {
                bubbles: !0
            }))
        }, 300),
        So = (t, e) => {
            let n = t.closest("[data-instant-form-product-url]");
            if (!n) return;
            let o = n.querySelector('[data-instant-dynamic-content-source="QUANTITY_SELECT"]');
            if (!o) return;
            let i = parseInt(o?.value, 10);
            isNaN(i) && (i = 1);
            let r = e === "increment" ? i + 1 : i - 1;
            (r < 1 || r > 999) && (r > 999 || n.getAttribute("data-instant-repeater-type") !== "CART_ITEMS") || (o.value = r.toString(), To(o))
        },
        Lo = t => {
            let e = t.closest("[data-instant-form-product-url]");
            if (!e) return null;
            let n = lt(e),
                o = `${n}__${t.getAttribute("data-instant-option-name")}`,
                i = t.getAttribute("data-instant-option-value") ?? "",
                r = e.querySelectorAll(`input[name^="${n}__"]`),
                a = [];
            for (let s of r) s.name === o && a.push(s);
            if (a?.length === 1) a[0].value = i;
            else if (a?.length > 1) a.forEach(s => {
                s.checked = s.value === t.getAttribute("data-instant-option-value")
            });
            else {
                let s = document.createElement("input");
                e.appendChild(s), s.setAttribute("type", "hidden"), s.setAttribute("name", o), s.setAttribute("value", i)
            }
            e.dispatchEvent(new Event("change", {
                cancelable: !0,
                bubbles: !0
            }))
        },
        Po = t => {
            let e = t.closest("[data-instant-form-product-url]");
            if (!e) return null;
            let n = lt(e);
            X(e, `${n}__selling-plan-id`, t.getAttribute("data-instant-selling-plan-id") ?? ""), X(e, `${n}__selling-plan-name`, t.getAttribute("data-instant-selling-plan-name") ?? "");
            let o = e.querySelectorAll('[data-instant-type="SELLING_PLAN_PICKER"] select');
            Array.from(o).forEach(i => {
                i.value = t.getAttribute("data-instant-selling-plan-id") ?? ""
            }), e.dispatchEvent(new Event("change", {
                cancelable: !0,
                bubbles: !0
            }))
        },
        ge = async t => {
            let e = t.getAttribute("data-instant-action-type"),
                n = t.getAttribute("data-instant-action-id"),
                o = t.getAttribute("data-instant-action-variant-id");
            if ((t.getAttribute("disabled") === "disabled" || t.closest("[data-instant-form-product-url]")?.getAttribute("disabled") === "disabled" || t.getAttribute("data-instant-disabled") === "true") && !["select-variant-option", "select-selling-plan"].includes(e)) return !0;
            if (Dt()) switch (e) {
                case "add-to-cart":
                case "redirect-to-cart":
                    e = "add-to-instant-cart";
                    break;
                case "open-cart":
                case "trigger-cart":
                    e = "trigger-instant-cart";
                    break
            }
            switch (e) {
                case "add-to-cart":
                case "add-to-instant-cart":
                case "redirect-to-cart":
                case "redirect-to-checkout":
                case "toggle-addon":
                    let i = yt(t),
                        r = t.closest("[data-instant-form-product-url]");
                    if (!i && e !== "toggle-addon" || !r) return null;
                    let a = "1";
                    i && (a = new URL(i).pathname.split(":").pop() ?? "1");
                    let s = t.getAttribute("data-instant-discount-code"),
                        l = t.getAttribute("data-instant-clear-cart") === "true",
                        u = t.getAttribute("data-instant-addon-visibility") === "hidden",
                        c = lt(r),
                        d = r.querySelector(`input[name="${c}__selling-plan-id"]`),
                        f = r.querySelector(`input[name="${c}__selling-plan-name"]`),
                        p = r.getAttribute("data-instant-form-selling-plan-id"),
                        {
                            sellingPlans: h
                        } = $t(r, c);
                    if (r.classList.contains("timesact-form")) {
                        let m = Me(r);
                        m && (p = m)
                    }
                    if (d?.value || f?.value)
                        if (d?.value === "one-time-purchase") p = null;
                        else {
                            let m = h.find(g => (g.sellingPlanId === d?.value || g.sellingPlanName === decodeURIComponent(f?.value ?? "")) && g.variantId === o);
                            m?.sellingPlanId && (p = m.sellingPlanId)
                        } St(t, !0), l && await fetch(`${window.Shopify?.routes?.root}cart/clear.js`, {
                        method: "POST"
                    }).catch(m => {
                        console.error("Failed to clear cart", m)
                    }), s && (document.cookie = `discount_code=${s}; path=/`, await fetch(`${window.Shopify?.routes?.root}discount/${s}`).catch(m => {
                        console.error("Failed to set discount code", m)
                    }));
                    let b = [],
                        w = [];
                    if (e === "add-to-cart" || e === "add-to-instant-cart" || e === "toggle-addon") {
                        let m = document.querySelector('.__instant[data-instant-layout="CART"]');
                        m && b.push(m), b.push(...Array.from(document.querySelectorAll('[data-instant-dynamic-content-source="CART_COUNT"]'))), b.forEach(g => {
                            if (w.length >= 5) return;
                            let H = g.closest(".__instant")?.getAttribute("data-section-id");
                            H && !w.includes(H) && w.push(H)
                        })
                    }
                    let A = [],
                        S = Vt(r),
                        x = t.getAttribute("data-instant-state") === "active",
                        I = !1,
                        M;
                    if (e === "toggle-addon" && x) I = !0, M = {
                        id: o,
                        quantity: 0,
                        sections: w.length > 0 ? w.join(",") : void 0
                    };
                    else {
                        if (S) A.push(...S.items());
                        else {
                            A.push({
                                id: parseInt(o, 10),
                                quantity: e === "toggle-addon" ? 1 : parseInt(a, 10),
                                ...p && p !== "one-time-purchase" ? {
                                    selling_plan: parseInt(p, 10)
                                } : {}
                            });
                            let T = r.querySelectorAll('input[name^="properties["]');
                            if (T.length > 0) {
                                let O = {};
                                for (let v of T) {
                                    if (vo(v)) continue;
                                    if (!v.checkValidity()) return v.reportValidity(), St(t, !1), !0;
                                    let q = v.name.match(/properties\[(.*?)\]/)?.[1];
                                    q && v.value && (v.type !== "radio" || v.checked) && (O[q] = v.value)
                                }
                                A.forEach(v => {
                                    v.properties = O
                                })
                            }
                        }
                        let m = ht(t),
                            g = ve(t),
                            H = m && g ? `${g}:${m}` : "";
                        A.forEach(T => {
                            let O = e === "toggle-addon" && u;
                            T.properties = {
                                ...T.properties,
                                ...H && {
                                    "_instant-ref": H
                                },
                                ...O && {
                                    "_instant-hidden": "true"
                                }
                            }
                        }), M = {
                            items: A,
                            sections: w.length > 0 ? w.join(",") : void 0
                        }
                    }
                    fetch(`${window.Shopify?.routes?.root}cart/${I ? "change" : "add"}.js`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(M)
                    }).then(m => {
                        if (!m.ok) throw new Error;
                        switch (e) {
                            case "redirect-to-cart":
                                window.location.href = `${window.Shopify?.routes?.root}cart`;
                                break;
                            case "redirect-to-checkout":
                                window.location.href = `${window.Shopify?.routes?.root}checkout`;
                                break;
                            case "add-to-cart":
                            case "add-to-instant-cart":
                            case "toggle-addon":
                            default:
                                let g = new CustomEvent("instant:add-to-cart", {
                                    bubbles: !1,
                                    detail: {
                                        useInstantCart: e === "add-to-instant-cart"
                                    }
                                });
                                document.dispatchEvent(g), m.json().then(({
                                    sections: H
                                }) => {
                                    if (qt(b, H, {
                                            resetScroll: e !== "toggle-addon",
                                            resetCountdowns: !0
                                        }), e === "add-to-instant-cart") {
                                        let T = document.querySelector('[data-instant-layout="CART"] > [data-instant-type="root"] > [data-instant-type="overlay"]');
                                        if (T && T.getAttribute("data-state") === "closed") {
                                            G(T);
                                            let O = ht(T);
                                            It(O)
                                        } else T || (console.warn("[Instant] Instant cart overlay not found"), window.location.href = `${window.Shopify?.routes?.root}cart`)
                                    }
                                })
                        }
                    }).catch(() => {
                        let m = document.createElement("form");
                        m.setAttribute("method", "POST"), m.setAttribute("action", `${window.Shopify?.routes?.root}cart/add`), m.setAttribute("novalidate", "novalidate"), [
                            ["id", o ?? ""],
                            ["product-id", n ?? ""],
                            ["selling_plan", p ?? ""],
                            ["form_type", "product"],
                            ["quantity", a],
                            ["utf8", "\u2713"], ...Object.entries(A[0]?.properties ?? {}).map(([g, H]) => [`properties[${g}]`, H.toString()])
                        ].forEach(([g, H]) => {
                            let T = document.createElement("input");
                            T.setAttribute("type", "hidden"), T.setAttribute("name", g), T.setAttribute("value", H), m.appendChild(T)
                        }), document.body.appendChild(m), m.submit()
                    }).finally(() => {
                        St(t, !1)
                    });
                    break;
                case "scroll-to-section":
                    n && Eo(n);
                    break;
                case "quantity-increment":
                case "quantity-decrement":
                    So(t, e === "quantity-increment" ? "increment" : "decrement");
                    break;
                case "adjust-line-item-quantity":
                    let _ = t.getAttribute("data-instant-action-line-item-key");
                    Xt({
                        id: _,
                        quantity: 0
                    });
                    break;
                case "select-variant-option":
                    Lo(t);
                    break;
                case "select-selling-plan":
                    Po(t);
                    break;
                case "open-dropdown":
                    Tt(t, "dropdown");
                    break;
                case "open-overlay":
                    Tt(t, "overlay");
                    break;
                case "trigger-cart":
                case "trigger-instant-cart":
                    let R = new CustomEvent("instant:open-cart", {
                        bubbles: !1,
                        detail: {
                            useInstantCart: e === "trigger-instant-cart"
                        }
                    });
                    if (document.dispatchEvent(R), e === "trigger-instant-cart") {
                        let m = document.querySelector('[data-instant-layout="CART"] [data-instant-type="overlay"]');
                        if (m && m.getAttribute("data-state") === "closed") {
                            G(m);
                            let g = ht(m);
                            It(g)
                        } else m || (console.warn("[Instant] Instant cart overlay not found"), window.location.href = `${window.Shopify?.routes?.root}cart`)
                    }
                    break;
                case "open-page":
                case "open-cart":
                    return !1;
                case "load-more":
                    return Re(t);
                case "clear-filters":
                    return qe(t);
                default:
                    return console.warn(`Unknown instant action type: ${e}`), !1
            }
            return !0
        }, vn = t => {
            let e = t.querySelectorAll(['a[data-instant-action-type]:not([data-instant-action-type^="open-"]):not([data-instant-action-on-hover])', "button[data-instant-action-type]:not([data-instant-action-on-hover])", "div[data-instant-action-type]:not([data-instant-action-on-hover])"].join(", "));
            Array.from(e).forEach(o => {
                o.addEventListener("click", i => {
                    i.preventDefault(), i.stopPropagation();
                    let r = i.currentTarget;
                    return !r || !(r instanceof HTMLElement) ? null : ge(r)
                }, {
                    signal: window.Instant.eventAbortController.signal
                })
            });
            let n = document.querySelectorAll('.__instant div[href], .__instant form[href], .__instant div[data-instant-href], .__instant form[data-instant-href], .__instant form[data-instant-action-type="toggle-addon"]');
            Array.from(n).forEach(o => {
                o.addEventListener("click", i => {
                    let r = i.currentTarget;
                    if (!r || !(r instanceof HTMLElement)) return null;
                    let a = ut(i.target);
                    i.target instanceof HTMLLabelElement || i.target instanceof HTMLInputElement || i.target instanceof HTMLFieldSetElement || i.target instanceof HTMLAnchorElement || i.target instanceof HTMLButtonElement || a instanceof HTMLAnchorElement || a instanceof HTMLButtonElement || a instanceof HTMLInputElement || a instanceof HTMLLabelElement || a instanceof HTMLFieldSetElement || (i.preventDefault(), i.stopPropagation(), ge(r).then(s => {
                        if (s) return;
                        let l = yt(r),
                            u = r.getAttribute("target"),
                            c = r.getAttribute("rel");
                        l && window.open(l, u || "_self", c || void 0);
                        let d = ut(i.target);
                        if (!(i.target instanceof HTMLLabelElement || i.target instanceof HTMLInputElement || i.target instanceof HTMLFieldSetElement || i.target instanceof HTMLAnchorElement || i.target instanceof HTMLButtonElement || d instanceof HTMLAnchorElement || d instanceof HTMLButtonElement || d instanceof HTMLInputElement || d instanceof HTMLLabelElement || d instanceof HTMLFieldSetElement)) return i.preventDefault(), i.stopPropagation(), ge(r).then(f => {
                            if (f) return;
                            let p = r.getAttribute("href"),
                                h = r.getAttribute("target"),
                                b = r.getAttribute("rel");
                            p && window.open(p, h || "_self", b || void 0)
                        })
                    }))
                }, {
                    signal: window.Instant.eventAbortController.signal
                })
            })
        };
    var ye = t => t?.replace(/gid:\/\/shopify\/.*\//im, ""),
        Io = (t, e) => e ? t?.find(n => n.id === Number(ye(e))) : t?.[0],
        xo = kt(async (t, e) => {
            let n = parseInt(t.target?.value, 10);
            isNaN(n) && (n = 1);
            let o = e.querySelectorAll('input[data-instant-dynamic-content-source="QUANTITY_SELECT"]');
            for (let i of o) i.value = n.toString();
            if (t.target?.closest('[data-instant-layout="CART"]')) {
                let i = e.getAttribute("data-instant-form-line-item-key");
                St(e, !0);
                try {
                    await Xt({
                        id: i,
                        quantity: n
                    })
                } finally {
                    e?.isConnected && St(e, !1)
                }
                setTimeout(() => {
                    document.querySelector(`input[id="${t.target?.id}"]`)?.focus()
                }, 300)
            }
        }, 600),
        Tn = t => {
            let e = t.querySelectorAll(".__instant form[data-instant-form-product-url]");
            Array.from(e).forEach(n => {
                let o = n.querySelectorAll('input[data-instant-dynamic-content-source="QUANTITY_SELECT"]');
                Array.from(o).forEach(i => {
                    i.addEventListener("change", r => {
                        let a = i.getAttribute("min") ?? "1",
                            s = i.getAttribute("max") ?? "999",
                            l = parseInt(i.value, 10);
                        r.target instanceof HTMLInputElement && (l = parseInt(r.target.value, 10)), a && l < parseInt(a, 10) && (i.value = a), s && l > parseInt(s, 10) && (i.value = s), isNaN(l) && (i.value = a)
                    }, {
                        signal: window.Instant.eventAbortController.signal
                    })
                }), n.addEventListener("change", async i => {
                    let r = new FormData(i?.currentTarget),
                        a = i.target?.closest("[data-instant-form-product-url]");
                    if (!a) {
                        console.warn("No scope found for form change event");
                        return
                    }
                    let s = lt(a);
                    if (i.target instanceof HTMLSelectElement && i.target.name.endsWith("__selling_plan")) {
                        let T = a.querySelectorAll(`select[name="${i.target.name}"]`);
                        Array.from(T).forEach(O => {
                            O !== i.target && (O.value = i.target.value)
                        })
                    }
                    if (i.target?.closest("kaching-bundles-block") || i.target?.name?.startsWith("properties[") || i.target?.name === "quantity" && (xo(i, a), i.target?.closest('[data-instant-layout="CART"]'))) return;
                    let l = a?.getAttribute("data-instant-form-variant-id"),
                        u = a?.getAttribute("data-instant-form-selling-plan-id"),
                        {
                            variants: c,
                            options: d,
                            sellingPlans: f
                        } = $t(a, s),
                        p = Io(c, l),
                        h = [];
                    for (let [T, O] of r) T.startsWith(s) && h.push({
                        key: decodeURIComponent(T.replace(`${s}__`, "")),
                        value: String(O)
                    });
                    let b = [p?.option1, p?.option2, p?.option3],
                        w = [];
                    if (d)
                        for (let T of d) w.push(h.find(({
                            key: O
                        }) => O === T.name)?.value ?? b[T.position - 1]);
                    let A = c ? c?.find(({
                        option1: T,
                        option2: O,
                        option3: v
                    }) => {
                        let q = [T, O, v].filter(Boolean),
                            k = w.filter(Boolean);
                        return q.every((B, F) => B === k[F])
                    })?.id : l;
                    if (i.target?.name?.endsWith("__selling_plan")) {
                        let T = i.target?.value;
                        if (T === "one-time-purchase") X(a, `${s}__selling-plan-id`, "one-time-purchase"), X(a, `${s}__selling-plan-name`, encodeURIComponent("One Time Purchase"));
                        else {
                            let O = f?.find(v => v.variantId === A?.toString() && (v.sellingPlanId === T || v.sellingPlanName === T));
                            O && (X(a, `${s}__selling-plan-id`, O.sellingPlanId), X(a, `${s}__selling-plan-name`, encodeURIComponent(O.sellingPlanName)))
                        }
                    }
                    let S = document.querySelector(`input[name="${s}__selling-plan-id"]`),
                        x = document.querySelector(`input[name="${s}__selling-plan-name"]`),
                        I = ye(S?.value),
                        M = ye(x?.value),
                        _ = f?.find(T => T.variantId === A.toString() && (T.sellingPlanId === I?.toString() || T.sellingPlanName === decodeURIComponent(M?.toString() ?? "")));
                    !_ && I !== "one-time-purchase" && (_ = f?.find(T => T.variantId === A.toString() && T.sellingPlanId === u)), !_ && I && I !== "one-time-purchase" && (_ = f?.find(T => T.variantId === A.toString())), _ && (X(a, `${s}__selling-plan-id`, _.sellingPlanId), X(a, `${s}__selling-plan-name`, encodeURIComponent(_.sellingPlanName)));
                    let R = a.querySelector('input[name="id"]'),
                        m = a.querySelector('input[name="selling_plan"]');
                    R && A && (R.value = A.toString()), m && (m.value = I === "one-time-purchase" || !I ? "" : I);
                    let g = r.get("quantity"),
                        H = Vt(a);
                    H && (H.currentVariantId = parseInt(A), g && (H.quantity = parseInt(g.toString()))), Bt({
                        variantId: A,
                        scope: a,
                        scopeId: s,
                        quantity: g,
                        selectedSellingPlan: _
                    })
                }, {
                    signal: window.Instant.eventAbortController.signal
                })
            }), Array.from(e).forEach(n => {
                n.dispatchEvent(new Event("change"))
            })
        },
        Sn = t => {
            let e = t.querySelectorAll('fieldset[data-instant-type="filter-container"]');
            Array.from(e).forEach(n => {
                n.addEventListener("change", o => {
                    let i = o.target?.closest("[data-instant-form-collection-url]");
                    if (!i) {
                        console.warn("No scope found for form change event");
                        return
                    }
                    let r = o.target?.name,
                        a = o.target?.value;
                    if (!r || !a) {
                        console.warn("No filter type or value found");
                        return
                    }
                    zt({
                        scope: i,
                        url: ae({
                            key: r,
                            value: a
                        })
                    })
                }, {
                    signal: window.Instant.eventAbortController.signal
                })
            })
        },
        Ln = t => {
            let e = t.querySelectorAll('fieldset[data-instant-type="sort-container"]');
            Array.from(e).forEach(n => {
                n.addEventListener("change", o => {
                    let i = o.target?.closest("[data-instant-form-collection-url]");
                    if (!i) {
                        console.warn("No scope found for form change event");
                        return
                    }
                    let r = o.target?.value;
                    if (!r) {
                        console.warn("No sort option found");
                        return
                    }
                    zt({
                        scope: i,
                        url: ae({
                            key: "sort_by",
                            value: r
                        }, {
                            replace: !0
                        })
                    })
                }, {
                    signal: window.Instant.eventAbortController.signal
                })
            })
        };
    var Lt = "instant-scroll-trigger--hidden";

    function Co(t, e, n) {
        t.forEach(o => {
            let i = o.target;
            o.isIntersecting ? (i.classList.contains(Lt) && i.classList.remove(Lt), n || e.unobserve(i)) : n && i.classList.add(Lt)
        })
    }
    var Pn = t => {
        let e = t.querySelectorAll(".instant-scroll-trigger");
        e.length !== 0 && e.forEach(n => {
            let o = n.getAttribute("data-instant-scroll-into-view-replay") === "true",
                i = n.getAttribute("data-instant-scroll-into-view-offset") ? Number(n.getAttribute("data-instant-scroll-into-view-offset")) : 0;
            if (window.getComputedStyle(n).position === "fixed") {
                let a = !1,
                    s = () => {
                        if (window.scrollY < i) {
                            o && n.classList.add(Lt), a = !1;
                            return
                        }
                        n.classList.contains(Lt) && n.classList.remove(Lt), a = !1
                    },
                    l = () => {
                        a || (window.requestAnimationFrame(s), a = !0)
                    };
                window.addEventListener("scroll", l, {
                    signal: window.Instant.eventAbortController.signal
                })
            } else new IntersectionObserver((s, l) => Co(s, l, o), {
                root: document,
                threshold: 0,
                rootMargin: `${-i}px 0px`
            }).observe(n)
        })
    };
    var In = (t, e) => {
            let n = document.querySelector(`.i${t}`),
                o = document.querySelectorAll(`[data-instant-tab-id="${t}"]`);
            if (e)
                for (let i of e) i.setAttribute("data-instant-state", "closed");
            if (n && n.setAttribute("data-instant-state", "open"), o)
                for (let i of o) {
                    let a = i?.parentNode?.querySelectorAll(`:scope > [data-instant-type="tabs-trigger"]:not([data-instant-tab-id="${t}"])`);
                    if (a)
                        for (let s of a) s.setAttribute("data-instant-state", "inactive");
                    i.setAttribute("data-instant-state", "active")
                }
        },
        xn = (t, e) => {
            let n = document.querySelector(`.i${t}`);
            if (e)
                for (let o of e) o.style.setProperty("display", "none");
            n && n.style.removeProperty("display")
        },
        Cn = t => {
            let e = t.querySelectorAll('[data-instant-type="tabs-container"]'),
                n = t?.querySelectorAll('[data-instant-type="tabs-trigger"]');
            Array.from(e).forEach(o => {
                let a = o?.querySelector('[data-instant-type="tabs-pane"]')?.parentNode?.querySelectorAll(':scope > [data-instant-type="tabs-pane"]');
                a?.[0]?.id && (xn(a[0].id, a), window.requestAnimationFrame(() => In(a[0].id, a)))
            }), Array.from(n).forEach(o => {
                let i = o.getAttribute("data-instant-tabs-id"),
                    r = o.getAttribute("data-instant-tab-id");
                if (i && r) {
                    let u = document.querySelector(`.i${i}`)?.querySelector('[data-instant-type="tabs-pane"]')?.parentNode?.querySelectorAll(':scope > [data-instant-type="tabs-pane"]');
                    n && u && o.addEventListener("click", () => {
                        let c = o.getAttribute("data-instant-tab-id") || "";
                        xn(c, u), window.requestAnimationFrame(() => In(c, u))
                    }, {
                        signal: window.Instant.eventAbortController.signal
                    })
                }
            })
        };
    var Mn = () => {
        document.addEventListener("shopify:section:select", function(t) {
            let n = t.target?.querySelector('[data-instant-layout="CART"] [data-instant-type="overlay"]');
            n && n.getAttribute("data-state") === "closed" && G(n)
        }, {
            signal: window.Instant.eventAbortController.signal
        }), document.addEventListener("shopify:section:deselect", function(t) {
            let n = t.target?.querySelector('[data-instant-layout="CART"] [data-instant-type="overlay"]');
            n && n.getAttribute("data-state") === "open" && G(n)
        }, {
            signal: window.Instant.eventAbortController.signal
        })
    };
    var Hn = t => {
        let e = t.querySelectorAll('[data-instant-type="ticker"]');
        Array.from(e).reverse().forEach(n => {
            let o = n.querySelector(".instant-ticker-initial-child-container"),
                i = o?.closest(".instant-ticker"),
                r = i?.nextElementSibling,
                a = [i, r],
                s = n.getAttribute("data-instant-ticker-is-reversed") === "true",
                l = +(n.getAttribute("data-instant-ticker-speed") || 50),
                u = n.getAttribute("data-instant-ticker-pause") === "true" || !1;
            if (n && o) {
                let c = o.children,
                    d = 1,
                    f = 0,
                    p = () => {
                        let b = n.getBoundingClientRect(),
                            w = o.getBoundingClientRect();
                        if (b && w) {
                            let A = Math.min(b.width, 9999),
                                S = w.width,
                                x = window.getComputedStyle(o),
                                I = x.columnGap ? typeof x.columnGap == "number" ? `${x.columnGap}px` : x.columnGap : "0px";
                            n.style.setProperty("--gap", I), d = S && A && S < A ? Math.ceil(A / S) : 1, f = S * d / l
                        }
                        n.style.getPropertyValue("--multiplier") !== `${d}` && (i && i.replaceChildren(o), r && (r.innerHTML = ""), Array.from(a).forEach((A, S) => {
                            A && [...Array(Math.max(0, S === 0 ? d - 1 : d))].forEach(() => {
                                Array.from(c).forEach(x => {
                                    let I = x.cloneNode(!0);
                                    A.appendChild(I)
                                })
                            })
                        })), n.style.setProperty("--play", "running"), n.style.setProperty("--direction", s ? "reverse" : "normal"), n.style.setProperty("--duration", `${f}s`), n.style.setProperty("--pause-on-hover", u ? "paused" : "running"), n.style.setProperty("--multiplier", `${d}`), /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && n.querySelectorAll('img[loading="lazy"]').forEach(S => {
                            S.loading = "eager"
                        })
                    };
                p();
                let h = new ResizeObserver(p);
                h.observe(n), h.observe(o)
            }
        })
    };
    var Mo = t => {
            let e = t.querySelectorAll(".instant-localization-select select");
            Array.from(e).forEach(n => {
                let o = n;
                o.addEventListener("change", i => {
                    let r = o.name.split("--")[1] === "language" ? "locale_code" : "country_code",
                        a = document.createElement("form");
                    a.action = "/localization", a.method = "post", [{
                        name: "form_type",
                        value: "localization"
                    }, {
                        name: "_method",
                        value: "put"
                    }, {
                        name: "return_to",
                        value: window.location.pathname
                    }, {
                        name: r,
                        value: i.target.value
                    }].forEach(l => {
                        let u = document.createElement("input");
                        u.type = "hidden", u.name = l.name, u.value = l.value, a.appendChild(u)
                    }), document.body.appendChild(a), a.submit()
                }, {
                    signal: window.Instant.eventAbortController.signal
                })
            })
        },
        bt = () => {
            window.Instant.initializedListeners = !1, window.Instant.eventAbortController.abort(), window.Instant.eventAbortController = new AbortController, Pt()
        },
        Pt = t => {
            window.Instant.initializedListeners = !0;
            let e = document;
            if (t)
                if (t instanceof Element) e = t;
                else {
                    let n = document.getElementById(t);
                    n && (e = n)
                } Le(e), Te(e), vn(e), bn(e), wn(e), En(e), window.__instantInitSliders?.(e), Cn(e), Hn(e), hn(e), pn(e), gn(e), Tn(e), Ft(e), Sn(e), Ln(e), Ne(), Ut(e), Mo(e), Pn(e), Dt() && On(), Ce(), He(), window.Shopify.designMode && Mn(e)
        };
    var Ho = ["CART_COUNT", "CART_ORIGINAL_TOTAL_PRICE", "CART_SUBTOTAL_PRICE", "CART_TOTAL_DISCOUNT", "CART_TOTAL_PRICE", "CART_REWARD_THRESHOLD", "CART_REWARD_PROGRESS", "CART_REWARD_AMOUNT_LEFT"],
        qt = (t, e, n = {
            resetScroll: !1,
            resetCountdowns: !1
        }) => {
            t.forEach(i => {
                let r = i.closest(".__instant")?.getAttribute("data-section-id");
                if (r && e[r]) {
                    let a = P(i),
                        s = new DOMParser().parseFromString(e[r], "text/html"),
                        l = s.querySelector(`.${a}`);
                    if (l)
                        if (i.getAttribute("data-instant-layout") === "CART") {
                            i.querySelectorAll(Ho.map(c => `[data-instant-dynamic-content-source="${c}"]`).join(",")).forEach(c => {
                                let d = P(c),
                                    f = s.querySelector(`.${d}`);
                                f && (c.innerHTML = f.innerHTML)
                            }), i.querySelectorAll("[data-instant-product-recommendations]").forEach(c => {
                                let d = c.getAttribute("data-instant-product-recommendations"),
                                    f = s.querySelector(`[data-instant-product-recommendations="${d}"]`);
                                f && (c.replaceWith(f), f.parentElement && Ft(f.parentElement))
                            }), i.querySelectorAll(`[data-instant-action-type="toggle-addon"],[data-instant-conditional],[data-instant-type="cart-reward"],[data-instant-type="cart-reward-progression"],[data-instant-dynamic-content-source="${"CART_COUNT"}"]`).forEach(c => {
                                let d = P(c),
                                    f = s.querySelector(`.${d}`);
                                if (f) {
                                    if (c.getAttribute("data-instant-action-type") === "toggle-addon") {
                                        let h = c.getAttribute("data-instant-action-id"),
                                            b = f?.getAttribute("data-instant-action-id"),
                                            w = c.getAttribute("data-instant-action-variant-id"),
                                            A = f?.getAttribute("data-instant-action-variant-id");
                                        if (h !== b || w !== A) {
                                            let S = c.closest("[data-instant-form-product-url]");
                                            S && S.dispatchEvent(new Event("change"));
                                            return
                                        }
                                    } ["data-instant-state", "style"].forEach(h => {
                                        let b = f.getAttribute(h);
                                        b ? c.setAttribute(h, b) : c.removeAttribute(h)
                                    })
                                }
                            });
                            let u = [];
                            l.querySelectorAll('[data-instant-repeater-type="CART_ITEMS"]').forEach(c => {
                                c.parentElement && !u.includes(c.parentElement) && u.push(c.parentElement)
                            }), u.forEach(c => {
                                let d = i.querySelector(`.${P(c)}`);
                                if (d) {
                                    c.querySelectorAll("[data-instant-product-recommendations]").forEach(h => {
                                        let b = h.getAttribute("data-instant-product-recommendations"),
                                            w = d.querySelectorAll(`[data-instant-product-recommendations-item="${b}"]`);
                                        w.length && (Array.from(w).reverse().forEach(A => {
                                            h.insertAdjacentElement("afterend", A)
                                        }), h.remove())
                                    });
                                    let f = d.scrollTop,
                                        p = d.clientHeight;
                                    d.replaceWith(c), c.clientHeight <= p && !n.resetScroll && (c.scrollTop = f), Pt(c)
                                }
                            })
                        } else i.innerHTML = l.innerHTML
                }
            }), n.resetCountdowns && document.querySelectorAll('[data-instant-layout="CART"] [data-instant-type="countdown"]').forEach(i => {
                if (i.getAttribute("data-instant-countdown-date") || i.getAttribute("data-instant-countdown-is-persistent") === "true") return;
                let r = oe(i.id),
                    a = i.getAttribute("data-instant-countdown-minutes"),
                    s = new Date().getTime() + (a ? Number(a) : 0) * 60 * 1e3;
                window?.Shopify?.designMode || sessionStorage.setItem(r, `${s}`);
                let l = i.cloneNode(!0);
                ie(l), i.replaceWith(l)
            });
            let o = new CustomEvent("instant:cart-updated", {
                bubbles: !1
            });
            document.dispatchEvent(o)
        },
        _n = async () => {
            let t = [],
                e = Array.from(document.querySelectorAll('[data-instant-dynamic-content-source="CART_COUNT"],[data-instant-layout="CART"]'));
            e.forEach(i => {
                if (t.length >= 5) return;
                let r = i.closest(".__instant")?.getAttribute("data-section-id");
                r && !t.includes(r) && t.push(r)
            });
            let n = new URLSearchParams;
            t.forEach(i => n.append("sections[]", i));
            let o = await fetch(`cart?${n.toString()}`).then(i => {
                if (!i.ok) throw new Error;
                return i.json()
            });
            qt(e, o)
        }, he = t => {
            let e = document.querySelector('[data-instant-layout="CART"] [data-instant-type="overlay"]');
            if (e) {
                if (t !== void 0 && e.getAttribute("data-state") === "open" === t) return;
                G(e);
                let n = ht(e);
                It(n)
            } else console.warn("[Instant] Instant Cart layout not found")
        }, On = () => {
            let t = [
                ["a[href*='/cart']", ":not([href*='/cart/change'])", ":not([href*='/cart/add'])", ":not([href*='/cart/clear'])", ":not([href*='/pages/cart'])", ":not([href*='/products/cart'])", ":not([href*='/collections/cart'])", ":not([href*='/checkout'])", ":not([href*='/discount'])"].join(""), "#cart-icon-bubble"
            ];
            document.addEventListener("click", e => {
                try {
                    let n = e.target;
                    if (n && "closest" in n) {
                        let o = n.closest(t.join(","));
                        o && !o.hasAttribute("data-instant-action-type") && (e.stopImmediatePropagation(), e.preventDefault(), e.stopPropagation(), he(!0))
                    }
                } catch (n) {
                    console.error("Failed to handle custom cart click action", n)
                }
            }, {
                signal: window.Instant.eventAbortController.signal
            }), document.addEventListener("instant:cart-updated", () => {
                let e = document.querySelector("#cart-icon-bubble");
                e && fetch("/cart/update.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        updates: {},
                        sections: ["cart-icon-bubble"]
                    })
                }).then(n => n.json()).then(n => {
                    e.innerHTML = n.sections["cart-icon-bubble"]
                })
            }, {
                signal: window.Instant.eventAbortController.signal
            })
        };
    var Rn = () => {
        window.Instant.api = {
            updateCart: _n,
            toggleCart: he
        }
    };
    var qn = () => {};
    var Nn = t => {
        if (!window.Instant.initializedSwiper) {
            if (t.querySelector('[data-instant-type="slider"]')) {
                let r = document.createElement("script");
                r.onload = window.Instant.initSwiper, r.src = window.Instant.swiperScriptUrl || "https://client.instant.so/scripts/swiper-bundle.min.js", document.body.appendChild(r)
            }
            return
        }
        let e = {},
            n = (r, a = "slider") => {
                if (r && r.id) {
                    let s = document.getElementById(`instant-slider-${r.id}-params`),
                        l = r.closest(".__instant")?.getAttribute("data-section-id"),
                        u = r.getAttribute("data-instant-slider-id");
                    try {
                        if (s?.innerHTML) {
                            let c = JSON.parse(s.innerHTML);
                            if (l && c.navigation && (c.navigation.nextEl = `[data-section-id='${l}'] ${c.navigation.nextEl}`, c.navigation.prevEl = `[data-section-id='${l}'] ${c.navigation.prevEl}`), c.pagination) {
                                let d = `[data-section-id='${l}'] ${c.pagination.el}`,
                                    f = document.querySelector(d),
                                    p = f?.querySelector(".instant-slider-pagination-bullet");
                                if (c.pagination.el = d, f && p) {
                                    let h = P(p);
                                    c.pagination.renderBullet = (b, w) => `<span class="${w} ${h}"></span>`
                                }
                            }
                            if (c.on = c.on || {}, c.on.changeDirection = d => {
                                    if (d.params.direction === "horizontal") {
                                        let f = r.querySelector(":scope > .instant-slider-wrapper");
                                        f && (f.style.height = "")
                                    }
                                }, a === "thumbnails") {
                                let d = new Swiper(r, c);
                                e[`${u}`] = d
                            } else c.thumbs && e?.[`${u}`] && (c.thumbs = {
                                swiper: e?.[`${u}`],
                                ...c.thumbs
                            }), new Swiper(r, c)
                        }
                    } catch {}
                }
            },
            o = t.querySelectorAll('[data-instant-type="thumbnails"]');
        Array.from(o).forEach(r => {
            n(r, "thumbnails")
        });
        let i = t.querySelectorAll('[data-instant-type="slider"]');
        Array.from(i).forEach(r => {
            n(r)
        })
    };
    window.__instantInitSliders = (t = document) => {
        Nn(t)
    };
    var $n = () => {
        window.Instant.eventAbortController = new AbortController, Pt(), qn(), Rn(), window?.Shopify?.designMode && document.addEventListener("shopify:section:load", t => {
            let e = `shopify-section-${t.detail.sectionId}`;
            e && Pt(e)
        })
    };
    document.readyState !== "loading" ? $n() : document.addEventListener("DOMContentLoaded", () => {
        $n()
    });
})();